import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import Time from "../../../Time/Time";
// import { TypeInterface } from "../../../Entity/Entities/ContactForContract/Type/TypeInterface";
import { BalanceComponent } from "../../Partials/Balance/BalanceComponent";
// import { AlertsComponent } from "../../Partials/Alert/AlertsComponent";
import { Attachment } from "../../Partials/Attachment/Attachment";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { ContactForContractInterface } from "../../../Entity/Entities/ContactForContract/ContactForContractInterface";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { Timeline } from "../../Partials/Timeline/Timeline";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import UnitLookup from "../../Partials/Lookup/UnitLookup";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { Tenant } from "../../../Entity/Entities/Person/Role/Roles/Tenant";
import { None } from "../../../Entity/Entities/Person/Role/Roles/None";
import { Occupant as OccupantRole } from "../../../Entity/Entities/Person/Role/Roles/Occupant";
import { Occupant as OccupantType } from "../../../Entity/Entities/ContactForContract/Type/Types/Occupant";
import { ChargeTemplateCreate } from "../../Partials/Dialog/ChargeTemplateCreate";
import { ChargeTemplateUpdate } from "../../Partials/Dialog/ChargeTemplateUpdate";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Formatter from "../../../Localization/Formatter";
import ContractUpdateWillMount from "../../../Middleware/Middlewares/ContractUpdateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import * as moment from "moment";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import AgencyFeeContainer from "../../../Entity/Entities/AgencyFee/AgencyFeeContainer";
import { AgencyFeeCreate } from "../../Partials/Dialog/AgencyFeeCreate";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import EntityLaunchpanel from "../../Partials/Launchpanel/EntityLaunchpanel";
import { CoachCollectiveInvoiceDialog } from "../../Partials/Dialog/CoachCollectiveInvoiceDialog";
import ChargeCreateDialog from "../../Partials/Dialog/ChargeCreateDialog";
import Searchbar from "../../Partials/Searchbar/Searchbar";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { CoachNewTenantDialog } from "../../Partials/Dialog/CoachNewTenantDialog";
import ChargeTemplateCard from "../../Partials/ChargeTemplate/ChargeTemplateCard";
import ContractCard from "../../Partials/Contract/ContractCard";
import CasedeskUrl from "../../../Url/Url";
import CoachNewCharge from "../../Partials/Dialog/CoachNewCharge";
import { CoachIncreaseRentDialog } from "../../Partials/Dialog/CoachIncreaseRentDialog";
import { CoachRenewContract } from "../../Partials/Dialog/CoachRenewContract";
import { setTimeout } from "timers";
import { NewNotificationDialog } from "../../Partials/Dialog/NewNotificationDialog";

class ContractUpdate extends Component {
  protected timerId: any;
  private disablePersonId: number;
  private disableUnitId: number;
  private shortContractWarningPeriod: number = 1000 * 60 * 60 * 24 * 5;

  public state = {
    contract: null,
    ignoredPeople: [],
    id: 0,
    status: 1,
    firstDate: null,
    lastDate: null,
    finalRentalPeriodDate: null,
    openLeavePrompt: false,
    datepickerError: "",
    datepickerHint: "",
    amazonFolderName: null,
    canSelectTenant: false,
    isUpdating: false,
    note: "",
    isEndContractDialogOpen: false,
    isExpirationContractDialogOpen: false,
    isChangeEmailDialogOpen: false,
    endDate: Time.lastDateCurrentMonth(),
    endDateNotValid: false,
    expirationDate: null,
    hasModifiedData: false,
    removedPayments: [],
    paymentsFailedToRemove: [],
    deletedCharge: null,
    isReadonly: false,
    autoSelectTenantId: null,
    isRenewDialogOpen: false,
    isRenewCoachOpen: false,
    isAdjustRentCoachOpen: false,
    selectedTabIndex: 0,
    isSaving: false,
    tooltipOpen: false,
    isCheckEndDateIsFirstDateOfMonthDialogOpen: false,
    shouldSkipEndDateCheck: false,
    checkedEndDate: null,
    events: [],
    notifications: [],
    rentNotification: null,
    rentNotificationText: "",
    charges: [],
    fetchingEvents: true,
    isAgencyFeeDialogOpen: false,
    agencyFee: null,
    anchorElAgencyFees: null,
    isAgencyRemoveDialog: false,
    beta: false,
    attachments: [],
    removed: false,
    isDoYouWantToDeleteContractDialogOpen: false,
    intervalTickForRemoveButton: 5,
    labelForRemoveButton: this.trans("button-remove"),
    isRemoveButtonDisabled: true,
    anchorEl: null,
    nextPath: "",
    selectedTenant: null,
    selectedUnit: null,
    additionalFields: [],
    lastSelectedIndex: null,
    createdContract: null,
    selectedAgencyFee: null,
    isLaunchPanelOpen: false,
    isChargeCreatePopupOpen: false,
    isCoachNewChargeOpen: false,
    openChargeCreatePopupLaunchPanel: false,
    autoSendInvoiceToTenant: false,
    isPaidDirectlyToOwner: false,
    isCommercial: false,
    openCoachCreateNewTenant: false,
    showTenantEmailPopup: false,
    addressForRentEmail: "",
    notificationDialogIsOpen: false,
    ownerName: "",
    financialStartDate: null,
    agencyName: "",

    // signing popups
    isContractSigningPopupOpen: false,
    contractSigningPopupWasShown: false,
    isRentPriceCreatePopupOpen: false,
    rentPriceCreatePopupWasShown: false,
    isDepositPriceCreatePopupOpen: false,
    depositPriceCreatePopupWasShown: false,
    isPayUntilDatePopupOpen: false,
    payUntilDatePopupWasShown: false,
    payChargesUntilDate: null,
    shouldApplyPayChargesUntilDate: false,
    isSigningProcess: false,
    isAgencyFeeСreatePopupOpen: false,
    agencyFeeCreatePopupWasShown: false,
    isRentContractSigningPrePopupOpen: false,
    isDepositContractSigningPrePopupOpen: false,
    isAgencyFeeContractSigningPrePopupOpen: false,
    updatingNotificationDate: null,
    updatingNotificationText: '',
    // charge templates
    chargeTemplates: [],
    isChargeTemplatePopupOpen: false,
    newChargeTemplatePopupOpen: null,
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null,
    cannotDeleteSavingsChargeDialog: false,
    createChargesForNextPeriodDialogOpen: false,
    nextPeriodForCharges: null,
    isErrorLaunchPanelOpen: false,

    //coach create invoice PDF
    isCreateCollectiveInvoiceCoachOpen: false,
    unpaidContractCharges: [],
    isPreProcessCreateCollectiveInvoiceCoachOpen: false,
    isOpenAlreadyCreatedCollectiveInvoiceDialog: false,
    isOpenAlreadyPreProcessCreatedCollectiveInvoiceDialog: false,
    invoicePdfUrl: null,
    isContractSignPreProcessCollectiveInvoiceDilaog: false,
    typeOfCollectiveInvoice: null,
    isContractHaveEndDatePreProcessCollectiveInvoiceDialog: false,
    isCreatePdfPopupOpen: false,
    showAllFields: false,
    updatingEvent: null,

    //Notifications
    firstNotificationText: '',
    secondNotificationText: '',
    firstNotificationDate: null,
    secondNotificationDate: null,
    notificationWasModified: false,
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CONTRACT_UPDATE_CLEAR;

  protected middlewares: MiddlewareInterface[] = [
    ContractUpdateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);

    this.disablePersonId = parseInt(this.props.params.personId, 10);
    this.disableUnitId = parseInt(this.props.params.unitId, 10);

    if (this.disablePersonId !== 0) {
      const person: PersonInterface = this.props.app.persons.find(person => person.id === this.disablePersonId);

      if (!!person) {
        this.state.selectedTenant = person;
      }
    }

    if (this.disableUnitId !== 0) {
      const unit: UnitInterface = this.props.units.byId[this.disableUnitId];

      if (!!unit) {
        this.state.selectedUnit = unit;
      }
    }
  }

  public initializePage = (contract: ContractInterface) => {
    if (!contract) {
      return this.redirectBack();
    }

    this.props.dispatch({
      type: Constants.PAGE_CONTRACT_UPDATE_CLEAR
    });

    this.fetchContractCharges(contract?.id);
    this.fetchEntityEvents(contract?.id);

    let isReadonly;

    if (contract) {
      isReadonly = !contract.isConcept;
    }

    let selectedTabIndex = this.props.app.contractUpdatePageTabIndex;
    const usingBeta: boolean = this.props.app?.settings?.user?.beta;

    if (this.props?.location?.query?.financeTab && this.props?.location?.query?.financeTab === "true") {
      selectedTabIndex = 1;
    }

    let state = {
      contract: contract,
      selectedUnit: contract.unit,
      selectedTenant: contract.tenant,
      id: contract.id,
      status: contract.contractStatusId,
      note: contract.note,
      firstDate: contract.firstDate,
      lastDate: contract.lastDate,
      finalRentalPeriodDate: contract.finalRentalPeriodDate,
      checkinDate: contract.checkinDate,
      checkoutDate: contract.checkoutDate,
      ignoredPeople: [...contract.contractParties
        .map((contactForContract: ContactForContractInterface) => {
          return contactForContract.person;
        }), contract.person],
      canSelectTenant: contract.isConcept,
      payChargesUntilDate: contract.payChargesUntilDate || Time.lastDatePreviousMonth(),
      isSetPaymentUntilDateChecked: contract.payChargesUntilDate instanceof Date,
      endDate: contract.endDate,
      // expirationDate: contract.expirationDate,
      isReadonly: isReadonly,
      additionalFields: contract.contractParties
        .map((contactForContract: ContactForContractInterface) => {
          return {
            selectedPerson: contactForContract.person,
            description: contactForContract.description,
            contactForContractTypeId: contactForContract.type.getValue()
          };
        }),
      selectedTabIndex: selectedTabIndex,
      isAgencyFeeDialogOpen: false,
      agencyFee: null,
      anchorElAgencyFees: null,
      beta: usingBeta ? usingBeta : null,
      attachments: contract.attachments,
      removed: contract.removed,
      lastSelectedIndex: null,
      isErrorLaunchPanelOpen: false,
      autoSendInvoiceToTenant: contract?.autoSendInvoiceToTenant,
      addressForRentEmail: contract?.addressForRentEmail,
      isCommercial: contract?.isCommercial,
      financialStartDate: new Date(contract?.financialStartDate),
      agencyName: this.getAgency()?.name,
      ownerName: contract?.ownerName,

      // charge templates
      chargeTemplates: [...contract.chargeTemplates],
      isChargeTemplatePopupOpen: false,
      newChargeTemplatePopupOpen: null,
      anchorElChargeTemplate: null,
      selectedChargeTemplate: null,

      //coach create invoice PDF
      isCreateCollectiveInvoiceCoachOpen: false,
      unpaidContractCharges: [],
      isPreProcessCreateCollectiveInvoiceCoachOpen: false,
      isOpenAlreadyCreatedCollectiveInvoiceDialog: false,
      isOpenAlreadyPreProcessCreatedCollectiveInvoiceDialog: false,
      invoicePdfUrl: null,
      isContractSignPreProcessCollectiveInvoiceDilaog: false,
      typeOfCollectiveInvoice: null,
      isContractHaveEndDatePreProcessCollectiveInvoiceDialog: false,
      isPaidDirectlyToOwner: contract.chargeTemplates.length && contract.chargeTemplates.every(template => template.isPaidDirectlyToOwner),
    };

    if (Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const savedData = { ...state };
      const savedPeople = !!this.props.app.savedDataBeforeRedirecting.dataToBeSaved &&
        this.props.app.savedDataBeforeRedirecting.dataToBeSaved.ignoredPeople ?
        [...this.props.app.savedDataBeforeRedirecting.dataToBeSaved.ignoredPeople] :
        [];
      const createdPerson = this.props.app.savedDataBeforeRedirecting.createdPerson ?
        this.props.app.savedDataBeforeRedirecting.createdPerson :
        null;
      const ignoredPeople = createdPerson ? [{ ...createdPerson }, ...savedPeople] : [...savedPeople];
      const createdUnit = this.props.app.savedDataBeforeRedirecting.createdUnit ?
        this.props.app.savedDataBeforeRedirecting.createdUnit :
        null;

      const additionalFields = this.props.app?.savedDataBeforeRedirecting?.dataToBeSaved?.additionalFields;

      savedData.additionalFields = additionalFields;
      savedData.ignoredPeople = [...ignoredPeople];

      if (createdPerson) {
        savedData.selectedTenant = createdPerson;
      }

      if (createdUnit) {
        savedData.selectedUnit = createdUnit;
      }

      savedData.lastSelectedIndex = null;

      state = {
        ...state,
        ...savedData
      }
    }

    this.setState({
      ...state
    });
  }

  public componentWillReceiveProps(nextProps) {
    const prevId = parseInt(this.props.params.id, 10);
    const id = parseInt(nextProps.params.id, 10);
    const contract: ContractInterface = nextProps.app.contracts.filter((contract: ContractInterface) => contract.id === id)[0];
    const prevContract: ContractInterface = nextProps.app.contracts.filter((contract: ContractInterface) => contract.previousContractId === id)[0];

    this.setState({
      isReadonly: !!contract && !contract.isConcept ? true : false,
      attachments: nextProps?.component?.contract?.attachments
    });

    if (prevId !== id ||
      (!!contract && contract.contractStatus &&
        !!this.state.contract && !!this.state.contract.contractStatus &&
        (contract.contractStatus.toLowerCase() !== this.state.contract.contractStatus.toLowerCase()))) {
      this.initializePage(contract);
    } else {
      const chargeTemplates = [...this.state.chargeTemplates].filter(chargeTemplate => chargeTemplate?.contractId === contract?.id);
      const contractChargeTemplates = []

      !!contract && contract.chargeTemplates.forEach(chargeTemplate => {
        const stateChargeTemplateIds = chargeTemplates.map(chargeTemplate => chargeTemplate?.id);

        if (!stateChargeTemplateIds.includes(chargeTemplate?.id)) {
          contractChargeTemplates.push(chargeTemplate);
        } else {
          const stateChargeTemplateIndex = chargeTemplates.findIndex(stateChargeTemplate => stateChargeTemplate?.id === chargeTemplate?.id);
          chargeTemplates[stateChargeTemplateIndex] = chargeTemplate;
        }
      });

      this.setState({
        chargeTemplates: [...chargeTemplates, ...contractChargeTemplates],
        isPaidDirectlyToOwner: (chargeTemplates.length || contractChargeTemplates.length) && chargeTemplates.every(template => template.isPaidDirectlyToOwner)
          && contractChargeTemplates.every(template => template.isPaidDirectlyToOwner),
        contract: contract,
        attachments: [...!!contract ? contract.attachments : [], ...!!prevContract ? prevContract.attachments : []]
      });

      if (this.props.component?.contractIdHasUpdatedCharges === contract?.id) {
        this.props.dispatch({
          type: Constants.PAGE_CONTRACT_UPDATE_HAS_CHARGES_CHANGES,
          payload: {
            contractId: null
          }
        })

        this.fetchContractCharges(contract?.id);
      }
    }
  }

  public componentDidMount(): void {
    document.addEventListener('click', this.clickOutside, false);
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.clickOutside, false);
  }

  public switchIsPaidDirectlyToOwner = () => {
    this.state.chargeTemplates?.forEach(template => {
      this.updateChargeTemplate({
        ...template.data,
        amount: template.data.amount / 100,
        isPaidDirectlyToOwner: !this.state.isPaidDirectlyToOwner,
        currency: 1,
        repeatPeriod: template.data.repeatPeriod.id,
        type: template.data.type.id,
        paymentOffset: template.data.paymentOffset?.getValue()

      })
    })

    this.setState({
      isPaidDirectlyToOwner: !this.state.isPaidDirectlyToOwner
    })

  }

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        contractId: entityId
      },
      onSuccess: data => {
        const contractEvents: EventInterface[] = data.events
          .filter((event: EventInterface) => !event.removed);

        const notifications = data.events.filter(event => [3, 16].includes(event.eventTypeId))

        this.setState({
          events: [...contractEvents],
          fetchingEvents: false,
          notifications,
          firstNotificationText: notifications[0]?.content?.name,
          secondNotificationText: notifications[1]?.content?.name,
          firstNotificationDate: notifications[0]?.remindDate || null,
          secondNotificationDate: notifications[1]?.remindDate || null,
        });
      },
      onError: (e) => {
        console.log(e)
      }
    });
  }


  public updateRentNotification = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_CREATE_CLEAR
    });

    if (this.state.notifications[0]?.data.remindDate !== this.state.firstNotificationDate
      || this.state.notifications[0]?.data.content?.name !== this.state.firstNotificationText) {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          id: this.state.notifications[0]?.data.id,
          content: { name: this.state.firstNotificationText },
          remindDate: Time.formatOrNull(this.state.firstNotificationDate),
          reacted: false,
          contractId: this.state.contract?.id,
          removed: this.state.firstNotificationDate || this.state.firstNotificationText ? false : true,
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            notificationWasModified: false,
          }, () => this.initializePage(this.state.contract));
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            error: err
          })
        }
      });
    }

    if (this.state.notifications[1]?.data.remindDate !== this.state.secondNotificationDate
      || this.state.notifications[1]?.data.content?.name !== this.state.secondNotificationText) {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          id: this.state.notifications[1]?.data.id,
          content: { name: this.state.secondNotificationText },
          remindDate: Time.formatOrNull(this.state.secondNotificationDate),
          reacted: false,
          contractId: this.state.contract?.id,
          removed: this.state.secondNotificationDate || this.state.secondNotificationText ? false : true,
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            notificationWasModified: false,
          }, () => this.initializePage(this.state.contract));
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            error: err
          })
        }
      });
    }
  }

  public clickOutside = (e) => {
    if (e.target != document.getElementById('tooltip-block')) {
      if (e.target != document.getElementById('hidden-hint')) {
        this.setState({
          tooltipOpen: false
        });
      } else {
        this.setState({
          tooltipOpen: true
        });
      }
    }
  }

  public openEndContractDialog = () => {
    this.setState({
      isEndContractDialogOpen: true,
      anchorEl: null
    });
  }

  public closeEndContractDialog = () => {
    this.setState({
      isEndContractDialogOpen: false
    });
  }

  public startCollectiveInvoiceCreateProcess = (type) => {
    this.setState({
      typeOfCollectiveInvoice: type
    }, () => {
      if (!this.state.contract?.isActive && type === "first") {
        this.setState({
          isContractSignPreProcessCollectiveInvoiceDilaog: true
        });
      } else if (!this.state.contract?.endDate && type === "last") {
        this.setState({
          isContractHaveEndDatePreProcessCollectiveInvoiceDialog: true
        });
      } else {
        this.saving(() => {
          this.props.dispatch({
            type: Constants.GLOBAL_CHECK_COLLECTIVE_INVOICE_EXIST_START,
            payload: {
              contractId: this.state.contract?.id,
              type: type
            },
            onSuccess: url => {
              if (url) {
                this.setState({
                  isOpenAlreadyPreProcessCreatedCollectiveInvoiceDialog: true,
                  isSaving: false,
                  invoicePdfUrl: url
                });
              } else {
                this.fetchContractUnpaidCharges(this.state.contract?.id);
              }
            },
            onError: () => {
              this.setState({
                isSaving: false
              });
            }
          });
        })
      }
    })
  }

  public fetchContractUnpaidCharges = (contractId: number) => {
    this.saving(() => {
      const payload: any = {
        contractId: contractId,
        isAfterStartDate: 1, // do not fetch charges before start date
        sortByPeriod: true
      };

      // if (this.state.typeOfCollectiveInvoice === "first") {
      payload.paid = 0; // for first invoice we need only unpaid charges
      // }

      this.props.dispatch({
        type: Constants.GLOBAL_CHARGES_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: data => {
          if (data?.charges?.length > 0) {
            this.setState({
              unpaidContractCharges: [...data.charges],
              isSaving: false
            }, () => {
              this.setState({ anchorEl: null, isCreateCollectiveInvoiceCoachOpen: true });
            });
          } else {
            this.setState({ anchorEl: null, isSaving: false, isPreProcessCreateCollectiveInvoiceCoachOpen: true });
          }
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    })
  }

  public saveEndDate = (contract: ContractInterface) => {
    let date = this.state.endDate

    this.setState({
      endDateNotValid: false,
    }, () => {
      if (!(date instanceof Date && !isNaN(Number(date)))) {
        return this.setState({ endDateNotValid: true })
      }

      this.saving(() => {
        return this.props.dispatch({
          type: Constants.GLOBAL_CONTRACT_END_START,
          payload: {
            contractId: contract.id,
            endDate: this.state.endDate
          },
          onSuccess: () => {
            this.setState({
              isSaving: true
            }, () => {
            this.fetchContractCharges(this.state.contract && this.state.contract.id);
            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
            });
              this.props.dispatch({
                type: Constants.SNACKBAR_ADD_MESSAGE,
                payload: {
                  message: this.state.endDate > new Date() ?
                    `${this.trans("dialog/postprocess-endcontract-ending-info-1", { endDate: this.formatter.formatDate(this.state.endDate) })} ${this.trans("dialog/postprocess-endcontract-ending-info-2")}` :
                    `${this.trans("dialog/postprocess-endcontract-ended-info-1", { endDate: this.formatter.formatDate(this.state.endDate) })}`,
                  type: "info"
                }
            });
            this.setState({
              isSaving: false
            })
          });
          },
          onError: () => {
            this.setState({
              isSaving: false
            });
          }
        });
      });

      this.setState({
        isEndContractDialogOpen: false
      });
    });
  }

  public clearEndDate = (contract: ContractInterface) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_END_START,
        payload: {
          contractId: contract.id,
          endDate: null
        },
        onSuccess: () => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });
          this.setState({
            isSaving: false
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public openExpirationContractDialog = (event) => {
    this.setState({
      isExpirationContractDialogOpen: true,
      updatingNotificationDate: Time.formatOrNull(event.remindDate),
      updatingNotificationText: event.content?.name,
      updatingEvent: event
    });
  }

  public closeExpirationContractDialog = () => {
    this.setState({
      isExpirationContractDialogOpen: false,
      updatingNotificationDate: null,
      updatingNotificationText: "",
      updatingEvent: null,
    });
  }

  public openChangeEmailDialogOpen = () => {
    this.setState({
      isChangeEmailDialogOpen: true
    });
  }

  public closeChangeEmailDialogOpen = () => {
    this.setState({
      isChangeEmailDialogOpen: false
    });
  }


  public openTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  public saveExpirationDate = (event) => {
    this.saving(() => {
      return this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          id: event?.id,
          content: { name: this.state.updatingNotificationText },
          remindDate: Time.formatOrNull(this.state.updatingNotificationDate),
          contractId: this.state.contract?.id
        },
        onSuccess: () => {
          this.fetchEntityEvents(this.state.contract?.id)
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          this.setState({
            isSaving: false
          }, this.closeExpirationContractDialog);
        },
        onError: () => {
          this.setState({
            expirationDate: this.state.contract?.expirationDate,
            isSaving: false
          });
        }
      });
    });
  }

  public saveAddressForRentEmail = (contract: ContractInterface) => {
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_START,
      payload: {
        contractId: contract.id,
        autoSendInvoiceToTenant: this.state.autoSendInvoiceToTenant,
        addressForRentEmail: this.state.addressForRentEmail
      },
      onSuccess: () => {
        this.setState({
          autoSendInvoiceToTenant: this.state.autoSendInvoiceToTenant,
          addressForRentEmail: this.state.addressForRentEmail,
          isSaving: false
        });
      },
      onError: () => {
        this.setState({
          addressForRentEmail: this.state.contract?.addressForRentEmail,
          isSaving: false
        });
      }
    });

  }

  public addAdditionalFields = (): void => {
    const additionalFields = [...this.state.additionalFields];

    additionalFields.push({
      selectedPerson: null,
      description: this.trans("label-occupant"),
      contactForContractTypeId: OccupantType.contactForContractTypeId
    });

    this.setState({ additionalFields: [...additionalFields] });

    this.forceUpdate();
  }

  public renderAdditionalFields = (): any => {
    return this.state.additionalFields?.length > 0 && this.state.additionalFields?.map((data: any, index: number) => {
      if (!data) {
        return;
      }

      return (
        <div
          key={index}
          style={{ margin: "-14px 0", position: "relative" }}
        >
          <PersonLookup
            {...this.props}
            filterOutEntities={this.state.additionalFields}
            isInlineBlock={true}
            width="100%"
            containerWidth="60%"
            disabled={this.state.isReadonly || this.state.removed}
            onFocus={() => this.setState({ lastSelectedIndex: index })}
            autoSelectId={data.selectedPerson ? data.selectedPerson.id : null}
            floatingLabelText={this.trans("dropdown-selectperson-label")}
            onSelect={this.selectAdditionalPerson}
            onClear={person => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].selectedPerson = null;

              this.setState({
                additionalFields: [...additionalFields],
                ignoredPeople: this.state.ignoredPeople.filter(p => p.id !== person.id)
              }, () => {
                this.setModifiedData();
              });
            }}
            forceUpdatePage={true}
            saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect}
            error={this.getErrorFor(`contactForContracts[${index + 1}].contactId`)}
          />

          <TextField
            autoComplete="off"
            className="form-element"
            style={{
              width: "30%",
              boxSizing: "border-box",
              marginLeft: "45px",
            }}
            type="text"
            label={this.trans("label-description")}
            value={this.state.additionalFields[index].description}
            onChange={e => {
              const additionalFields = [...this.state.additionalFields];
              additionalFields[index].description = (e.currentTarget as any).value;
              this.setState({ additionalFields: [...additionalFields] });
              this.setModifiedData();
            }}
            variant="standard"
            disabled={this.state.isReadonly || this.state.removed}
            error={false}
          />

          <div
            className="icon icon-ic-close clear-button"
            style={{
              display: this.state.isReadonly || this.state.removed ? "none" : "inline-block",
              position: "absolute",
              top: "25px",
              right: "0px",
              cursor: "pointer"
            }}
            onClick={this.removeAdditionalField.bind(this, index)}
          ></div>
        </div>
      );
    });
  }

  public removeAdditionalField = (index: number): void => {
    const additionalFields = [...this.state.additionalFields];
    additionalFields.splice(index, 1);

    this.setState({
      additionalFields: [...additionalFields],
      hasModifiedData: true
    });

    this.forceUpdate();
  }

  public setDroppedStatus = (_contract: ContractInterface) => {
    const payload: any = {
      contract: {
        id: this.state.id,
        status: this.props.app.contractStatuses["DROPPED"],
        firstDate: this.state.firstDate,
        lastDate: this.state.lastDate,
        finalRentalPeriodDate: this.state.finalRentalPeriodDate,
        expirationDate: this.state.expirationDate,
        payChargesUntilDate:
          (this.state.firstDate < Time.firstDateCurrentMonth()) && this.state.contract && this.state.contract.isConcept &&
            this.state.shouldApplyPayChargesUntilDate === true
            ? this.state.payChargesUntilDate
            : null,
        note: this.state.note,
        unitId: this.state.selectedUnit?.id
      },
      unitId: this.state.selectedUnit?.id,
      chargeTemplates: this.state.chargeTemplates,
      additionalFields: this.state.additionalFields,
      autoSendInvoiceToTenant: this.state.autoSendInvoiceToTenant,
      addressForRentEmail: this.state.addressForRentEmail,
      isCommercial: this.state.isCommercial,
    }

    if (this.state.selectedTenant instanceof Person) {
      payload.selectedPerson = this.state.selectedTenant;
    }

    if (this.state.selectedTenant instanceof Company) {
      payload.selectedCompany = this.state.selectedTenant;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTRACT_UPDATE_START,
        payload: {
          ...payload
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            anchorEl: null
          });
        },
        onError: () => {
          this.setState({
            isSaving: false,
            anchorEl: null
          });
        }
      });
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    // we should show dialog if end date is the first day of the month
    if (moment(date).date() === 1 && identifier === "endDate" && !this.state.shouldSkipEndDateCheck) {
      return this.setState(
        {
          isCheckEndDateIsFirstDateOfMonthDialogOpen: true,
          checkedEndDate: date
        }
      );
    }

    const prevFirstDate = !!this.state.firstDate ? new Date(this.state.firstDate) : null;
    const prevLastDate = !!this.state.lastDate ? new Date(this.state.lastDate) : null;
    const prevFinalDate = !!this.state.finalRentalPeriodDate ? new Date(this.state.finalRentalPeriodDate) : null;
    const prevExpirationDate = !!this.state.expirationDate ? new Date(this.state.expirationDate) : null;

    // Update the state
    this.setState({
      [identifier]: date,
      hasModifiedData: true,
      datepickerHint: "",
      datepickerError: ""
    }, () => {
      // Show the hint if contract period is pretty short, like 5-6 days
      if (!!this.state.firstDate && !!this.state.lastDate &&
        (this.state.lastDate.getTime() - this.state.firstDate.getTime()) <= this.shortContractWarningPeriod) {
        this.setState({
          datepickerHint: this.trans("last-date-of-period-pretty-close")
        });
      }

      if (identifier === "firstNotificationDate" || identifier === "secondNotificationDate") {
        this.setState({
          notificationWasModified: true,
        })
      }
      // when we change first date we also should syncronize value of last date if it wasn't changed manually
      if (identifier === "firstDate") {
        // we should also update the dates in charge templates
        // Put the current charge templates to the state of the component
        this.setState({
          chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
            let chargeTemplateFirstDate = chargeTemplate?.firstDate;
            let chargeTemplateDueDateFirstPayment = chargeTemplate?.dueDateFirstPayment;

            if (!!this.state.firstDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevFirstDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.firstDate;
            }

            if (!this.state.firstDate && !!chargeTemplate?.firstDate &&
              this.formatter.formatDate(prevFirstDate) === this.formatter.formatDate(chargeTemplate?.firstDate)) {
              chargeTemplateFirstDate = this.state.firstDate;
            }

            if (!!this.state.firstDate && !prevFirstDate && !chargeTemplate?.firstDate) {
              chargeTemplateFirstDate = this.state.firstDate;
            }

            if (!!this.state.firstDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevFirstDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.firstDate;
            }

            if (!this.state.firstDate && !!chargeTemplate?.dueDateFirstPayment &&
              this.formatter.formatDate(prevFirstDate) === this.formatter.formatDate(chargeTemplate?.dueDateFirstPayment)) {
              chargeTemplateDueDateFirstPayment = this.state.firstDate;
            }

            if (!!this.state.firstDate && !prevFirstDate && !chargeTemplate?.dueDateFirstPayment) {
              chargeTemplateDueDateFirstPayment = this.state.firstDate;
            }

            return chargeTemplate?.reinitialize({
              ...chargeTemplate,
              firstDate: chargeTemplateFirstDate,
              dueDateFirstPayment: chargeTemplateDueDateFirstPayment
            });
          })
        });

        // we should update last date if it wasn't changed manually
        if (!!this.state.firstDate && !!this.state.lastDate &&
          this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevFirstDate)) === this.formatter.formatDate(this.state.lastDate)) {
          return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.firstDate), "lastDate");
        }

        // if (Time.isBefore(this.state.firstDate, Time.substractMonth(this.state.lastDate, 2))) {
        //   return this.selectDate(Time.substractMonth(this.state.lastDate, 2), "expirationDate");
        // }

        if (!this.state.firstDate && !!this.state.lastDate &&
          this.formatter.formatDate(Time.nextYearPrevMonthLastDay(prevFirstDate)) === this.formatter.formatDate(this.state.lastDate)) {
          return this.selectDate(this.state.firstDate, "lastDate");
        }

        if (!!this.state.firstDate && !prevFirstDate && !this.state.lastDate) {
          return this.selectDate(Time.nextYearPrevMonthLastDay(this.state.firstDate), "lastDate");
        }
      }

      // If the identifier is lastDate, we also have to update finalRentalPeriodDate and expirationDate
      // if they were not updated manually
      if (identifier === "lastDate") {
        if (!!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
          this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
          this.selectDate(this.state.lastDate, "finalDate");
        }

        if (!this.state.lastDate && !!this.state.finalRentalPeriodDate &&
          this.formatter.formatDate(prevLastDate) === this.formatter.formatDate(this.state.finalRentalPeriodDate)) {
          this.selectDate(date, "finalDate");
        }

        if (!!this.state.lastDate && !prevLastDate && !prevFinalDate) {
          this.selectDate(date, "finalDate");
        }

        if (!!this.state.lastDate && !!this.state.expirationDate &&
          this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
          return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
        }

        if (!this.state.lastDate && !!this.state.expirationDate &&
          this.formatter.formatDate(Time.substractMonth(prevLastDate, this.props.app.settings.agency.notificationPeriod)) === this.formatter.formatDate(this.state.expirationDate)) {
          return this.selectDate(this.state.lastDate, "expirationDate");
        }

        if (!!this.state.lastDate && !prevLastDate && !prevExpirationDate) {
          return this.selectDate(Time.substractMonth(this.state.lastDate, this.props.app.settings.agency.notificationPeriod), "expirationDate");
        }
      }
    });
  }

  public openChargeTemplateCreatePopup = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
    });

    if (this.state.contract && this.state.contract.isReadonly) {
      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("you-can-not-update-charge-templates-for-active-contract"),
          type: "warning"
        }
      });
    }

    return this.setState({
      newChargeTemplatePopupOpen: true
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true,
      })
    });
  }

  public closeChargeTemplatePopup = () => {
    this.setState({
      isChargeTemplatePopupOpen: false,
      isUpdating: false
    });
  }

  public cancelSigningProcess = () => {
    return this.setState({
      isContractSigningPopupOpen: false,
      contractSigningPopupWasShown: false,
      isRentPriceCreatePopupOpen: false,
      rentPriceCreatePopupWasShown: false,
      isDepositPriceCreatePopupOpen: false,
      depositPriceCreatePopupWasShown: false,
      agencyFeeCreatePopupWasShown: false,
      isPayUntilDatePopupOpen: false,
      payUntilDatePopupWasShown: false,
      shouldApplyPayChargesUntilDate: false,
      isAgencyFeeСreatePopupOpen: false,
      isSigningProcess: false,
      isRentContractSigningPrePopupOpen: false,
      isDepositContractSigningPrePopupOpen: false,
      isAgencyFeeContractSigningPrePopupOpen: false
    });
  }

  public save = () => {
    if (this.state.firstNotificationText && !this.state.firstNotificationDate
      || !this.state.firstNotificationText && this.state.firstNotificationDate
      || !this.state.secondNotificationText && this.state.secondNotificationDate
      || this.state.secondNotificationText && !this.state.secondNotificationDate) {
      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("this-field-is-not-valid"),
          type: "error"
        }
      });
    }
    if (this.state.isSigningProcess) {

      if ((this.state.selectedTenant instanceof Company
        && !this.state.selectedTenant?.generalContact?.email
        && this.state.autoSendInvoiceToTenant)
        || (this.state.selectedTenant instanceof Person
          && !this.state.selectedTenant.email
          && this.state.autoSendInvoiceToTenant)) {
        return this.setState({
          showTenantEmailPopup: true
        })
      }

      const depositChargeTemplateExist =
        this.state.chargeTemplates?.some(template => {
          return template.type.id === TypeContainer.pickIdFromLabel("Deposit");
        });

      const rentChargeTemplateExist =
        this.state.chargeTemplates?.some(template => {
          return template.type.id === TypeContainer.pickIdFromLabel("Basic_rent");
        });

      if (!this.state.contractSigningPopupWasShown) {
        return this.setState({
          isContractSigningPopupOpen: true,
          isSigningProcess: true,
        });
      }

      if (!rentChargeTemplateExist && !this.state.rentPriceCreatePopupWasShown) {
        return this.setState({
          isRentContractSigningPrePopupOpen: true,
          isSigningProcess: true
        });
      }

      if (!depositChargeTemplateExist && !this.state.depositPriceCreatePopupWasShown) {
        return this.setState({
          isDepositContractSigningPrePopupOpen: true,
          isSigningProcess: true
        });
      }

      // if(this.state.contract && this.state.contract.defaultAgencyFees && this.state.contract.defaultAgencyFees.length < 1 && !this.state.agencyFeeCreatePopupWasShown) {
      //   return this.setState({
      //     isAgencyFeeContractSigningPrePopupOpen: true,
      //     isSigningProcess: true
      //   });
      // }

      // if (this.state.firstDate < Time.firstDateCurrentMonth() &&
      //     !this.state.payUntilDatePopupWasShown
      //   ) {
      //   return this.setState({
      //     isPayUntilDatePopupOpen: true,
      //     isSigningProcess: true
      //   });
      // }
    }

    const payload: any = {
      contract: {
        id: this.state.id,
        status: this.state.status,
        firstDate: this.state.firstDate,
        lastDate: this.state.lastDate,
        finalRentalPeriodDate: this.state.finalRentalPeriodDate,
        expirationDate: this.state.expirationDate,
        payChargesUntilDate:
          (this.state.firstDate < Time.firstDateCurrentMonth()) && this.state.contract && this.state.contract.isConcept &&
            this.state.shouldApplyPayChargesUntilDate === true
            ? this.state.payChargesUntilDate
            : null,
        note: this.state.note,
        unitId: this.state.selectedUnit?.id
      },
      unitId: this.state.selectedUnit?.id,
      chargeTemplates: this.state.chargeTemplates,
      additionalFields: this.state.additionalFields,
      autoSendInvoiceToTenant: this.state.autoSendInvoiceToTenant,
      addressForRentEmail: this.state.addressForRentEmail,
      isCommercial: this.state.isCommercial,
    }

    if (this.state.selectedTenant instanceof Person) {
      payload.selectedPerson = this.state.selectedTenant;
    }

    if (this.state.selectedTenant instanceof Company) {
      payload.selectedCompany = this.state.selectedTenant;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTRACT_UPDATE_START,
        payload: {
          ...payload
        },
        onSuccess: () => {
          if (this.state.notificationWasModified) {
            this.updateRentNotification()
          }

          if (this.state.isSigningProcess) {
            return this.props.dispatch({
              type: Constants.GLOBAL_CONTRACT_SIGN_START,
              payload: {
                id: this.state.contract?.id
              },
              onSuccess: () => {
                this.setState({
                  isSigningProcess: false,
                  isSaving: false,
                  hasModifiedData: false
                });

                this.props.dispatch({
                  type: Constants.SNACKBAR_ADD_MESSAGE,
                  payload: {
                    message: `${this.trans("contract-update-dialog-sign-post-process-message-1")} ${this.trans("contract-update-dialog-sign-post-process-message-2")}`,
                    type: "info"
                  }
                });
              },
              onError: () => {
                this.setState({
                  isSaving: false,
                  hasModifiedData: this.state.isSigningProcess ? this.state.hasModifiedData : true,
                  isSigningProcess: false,
                  contractSigningPopupWasShown: false
                });
              }
            });
          }

          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          return this.setState({
            isSaving: false,
            hasModifiedData: false,
          }, () => {
            if (this.state.nextPath) {
              return this.redirect(this.state.nextPath);
            }

            this.initializePage(this.state.contract);
          });
        },
        onError: () => {
          this.setState({
            isSaving: false,
            hasModifiedData: this.state.isSigningProcess ? this.state.hasModifiedData : true,
            isSigningProcess: false,
            contractSigningPopupWasShown: false
          });
        }
      });
    });
  }

  protected openChargeTemplateMenu = (event: any, chargeTemplate: ChargeTemplateInterface): void => {
    this.setState({
      selectedChargeTemplate: chargeTemplate,
      anchorElChargeTemplate: event.currentTarget
    });
  }

  protected closeChargeTemplateMenu = (): void => {
    this.setState({
      anchorElChargeTemplate: null
    });
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public chargeTemplateComparer = (a, b) => {
    return this.comparer(a?.repeatPeriod?.id, b?.repeatPeriod?.id) ||
      this.comparer(a?.type?.label, b?.type?.label);
  }

  public isNotificationValid = () => {
    if (this.state.updatingNotificationDate === null || !this.state.updatingNotificationText?.trim()) {
      return false
    }

    return true
  }

  public getChargeTemplates = () => {
    return [...this.state.chargeTemplates]
      .filter((chargeTemplate: ChargeTemplateInterface) => !!chargeTemplate)
      .sort(this.chargeTemplateComparer)
      .map((chargeTemplate: ChargeTemplateInterface) => {


        return (
          <TableRow
            hover
            key={chargeTemplate?.id}
            className={`clickable-entity`}
            onClick={() => {
              this.openChargeTemplateUpdatePopup(chargeTemplate);
            }}
          >
            <TableCell></TableCell>
            <TableCell style={{ width: "15%" }}>
              {this.formatter.formatNumber(chargeTemplate?.amount, chargeTemplate?.currency)}
            </TableCell>
            <TableCell style={{ width: "15%" }}>{Formatter.checkTranslationType(this.trans(chargeTemplate.repeatPeriod.label), chargeTemplate.repeatPeriod.label)}</TableCell>
            <TableCell style={{ width: "20%" }}>{Formatter.checkTranslationType(this.trans(chargeTemplate?.type?.label, {}, "", chargeTemplate?.type?.system), chargeTemplate?.type?.label, chargeTemplate?.type?.system)}</TableCell>
            <TableCell style={{ width: "10%" }}>
              {
                chargeTemplate?.isPaidDirectlyToOwner && (
                  <div style={{ padding: "2px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className="list-label creation-type-label">
                      {this.trans("label-direct")}
                    </div>
                  </div>

                )
              }
            </TableCell>
            <TableCell style={{ width: "20%" }}>{chargeTemplate.description}</TableCell>
            <TableCell style={{ width: "15%" }}>{this.formatter.formatDate(chargeTemplate.dueDateFirstPayment) || this.formatter.formatDate(chargeTemplate.firstDate)}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openChargeTemplateMenu(e, chargeTemplate)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElChargeTemplate}
                  open={Boolean(this.state.anchorElChargeTemplate) && this.state.selectedChargeTemplate && this.state.selectedChargeTemplate?.id === chargeTemplate?.id}
                  onClose={this.closeChargeTemplateMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.deleteChargeTemplate(this.state.selectedChargeTemplate)}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public selectUnit = (unit: UnitInterface, isManuallySelected: boolean): void => {
    this.setState({
      selectedUnit: unit,
      hasModifiedData: isManuallySelected
    });
  }

  public clearUnit = (): void => {
    this.setState({
      selectedUnit: null,
      hasModifiedData: true
    });
  }

  public focusUnit = (): void => {
    (this.refs.UnitLookup as any) && (this.refs.UnitLookup as any).refs.instance.hide();
  }

  public selectAdditionalPerson = (person: PersonInterface, isManuallySelected: boolean): void => {
    const additionalFields = [...this.state.additionalFields];

    if (isManuallySelected === true) {
      additionalFields[this.state.lastSelectedIndex].selectedPerson = person;
    }

    this.setState({
      hasModifiedData: isManuallySelected,
      additionalFields: [...additionalFields],
      ignoredPeople: [person, ...this.state.ignoredPeople]
    });
  }

  public addChargeTemplate = (chargeTemplate, callback?): any => {
    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_START,
        payload: {
          chargeTemplate: chargeTemplate,
          contractId: this.state.contract && this.state.contract.id
        },
        onSuccess: createdChargeTemplate => {
          this.closeChargeTemplatePopup();

          // Put the updated charge templates to the state of the component
          this.setState({
            chargeTemplates: [
              ...this.state.chargeTemplates.filter(chargeTemplate => chargeTemplate?.id !== createdChargeTemplate?.id),
              createdChargeTemplate
            ],
            isSaving: false
          }, () => {
            if (typeof callback === "function") {
              callback();
            }
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public openChargeTemplateUpdatePopup = (chargeTemplate: ChargeTemplateInterface): any => {
    if (this.state.contract && this.state.contract.isReadonly) {
      this.setState({
        anchorElChargeTemplate: null
      })

      // return this.props.dispatch({
      //   type: Constants.SNACKBAR_ADD_MESSAGE,
      //   payload: {
      //     message: this.trans("you-can-not-update-charge-templates-for-active-contract"),
      //     type: "warning"
      //   }
      // });
    }

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_CREATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR,
    });

    this.setState({
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      anchorElChargeTemplate: null,
      newChargeTemplatePopupOpen: false
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true
      })
    });
  }

  public updateChargeTemplate = (updatedChargeTemplate: ChargeTemplateInterface): any => {
    if (!this.state.contract?.isActive) {
      this.setState({
        isSaving: true
      }, () => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_START,
          payload: {
            chargeTemplate: updatedChargeTemplate
          },
          onSuccess: updatedChargeTemplate => {
            this.closeChargeTemplatePopup();

            // Put the updated charge templates to the state of the component
            this.setState({
              chargeTemplates: this.state.chargeTemplates.map(
                (chargeTemplate: ChargeTemplateInterface) => {
                  if (chargeTemplate?.id === updatedChargeTemplate?.id) {
                    return chargeTemplate?.reinitialize({ ...updatedChargeTemplate?.data });
                  }

                  return chargeTemplate;
                }
              ),
              isSaving: false
            });
          },
          onError: () => {
            this.setState({
              isSaving: false
            });
          }
        });
      })
    } else {
      this.setState({
        isSaving: true
      }, () => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_PAID_DIRECTLY_TO_OWNER_START,
          payload: {
            id: updatedChargeTemplate?.id,
            isPaidDirectlyToOwner: updatedChargeTemplate?.isPaidDirectlyToOwner,
            isCollective: updatedChargeTemplate?.isCollective
          },
          onSuccess: updatedChargeTemplate => {
            this.closeChargeTemplatePopup();

            // Put the updated charge templates to the state of the component
            this.setState({
              chargeTemplates: this.state.chargeTemplates.map(
                (chargeTemplate: ChargeTemplateInterface) => {
                  if (chargeTemplate?.id === updatedChargeTemplate?.id) {
                    return chargeTemplate?.reinitialize({ ...updatedChargeTemplate?.data });
                  }

                  return chargeTemplate;
                }
              ),
              isSaving: false
            });
          },
          onError: () => {
            this.setState({
              isSaving: false
            });
          }
        });
      });
    }
  }

  public deleteChargeTemplate = (chargeTemplate: ChargeTemplateInterface): any => {
    this.closeChargeTemplateMenu();

    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TEMPLATE_DELETE_START,
      payload: {
        chargeTemplate: chargeTemplate
      },
      onSuccess: deletedChargeTemplate => {
        this.setState({
          chargeTemplates: [...this.state.chargeTemplates].filter(chargeTemplate => chargeTemplate?.id !== deletedChargeTemplate?.id)
        })
      }
    });
  }

  public getChargeTemplatePopupContent = (): any => {
    if (this.state.isUpdating) {
      return (
        <ChargeTemplateUpdate
          {...this.props}
          entity={"contract"}
          chargeTemplate={this.state.selectedChargeTemplate}
          onSave={this.updateChargeTemplate}
          onCancel={this.closeChargeTemplatePopup}
          disabled={this.state.contract && this.state.contract.isReadonly}
          chargeTypes={TypeContainer.getChargeTypesForChargeTemplates("contract")}
        />
      );
    }

    return (
      <ChargeTemplateCreate
        {...this.props}
        entity={"contract"}
        selectedType={TypeContainer.pickIdFromLabel("Basic_rent")}
        firstDate={this.state.firstDate ? new Date(this.state.firstDate) : null}
        endDate={this.state.contract?.endDate}
        contact={this.state.selectedTenant instanceof Person ? this.state.selectedTenant : null}
        company={this.state.selectedTenant instanceof Company ? this.state.selectedTenant : null}
        onSave={this.addChargeTemplate}
        onCancel={this.closeChargeTemplatePopup}
        chargeTypes={TypeContainer.getChargeTypesForChargeTemplates("contract")}
        existingChargeTemplates={this.state.chargeTemplates}
      />
    );
  }

  public done = (): void => {
    if ((Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length > 0) && !this.state.contract?.isSigned) {
      this.state.hasModifiedData = true;
    }

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    if (this.browser.history.getPreviousPage().includes("contract/create")) {
      return this.redirectFewStepsBack(2);
    }

    return this.redirectBack();
  }

  public switchTab = (event, tabValue): any => {
    event

    this.setState({
      selectedTabIndex: tabValue
    });

    this.props.dispatch({
      type: Constants.PAGE_CONTRACT_UPDATE_SWITCH_TAB,
      payload: {
        index: tabValue
      }
    });
  }

  public setPaymentUntilDateChecked = () => {
    this.setState({
      shouldApplyPayChargesUntilDate: !this.state.shouldApplyPayChargesUntilDate
    })
  }

  public saveDetailsBeforeRedirect = () => {
    this.state.hasModifiedData = false;

    const savedDataBeforeRedirecting = { ...this.props.app.savedDataBeforeRedirecting };

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    const dataToBeSaved = { ...this.state };
    dataToBeSaved.hasModifiedData = true;
    savedDataBeforeRedirecting.dataToBeSaved = dataToBeSaved;

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
      payload: {
        savedDataBeforeRedirecting: { ...savedDataBeforeRedirecting }
      }
    });

    let contactRoleId = Tenant.contactRoleId;
    const indexForAdditionalPerson = this.state.lastSelectedIndex;

    if (Number.isInteger(indexForAdditionalPerson)) {
      if (this.state.additionalFields[indexForAdditionalPerson].contactForContractTypeId === 2) {
        contactRoleId = OccupantRole.contactRoleId;
      }

      if (this.state.additionalFields[indexForAdditionalPerson].contactForContractTypeId === 255) {
        contactRoleId = None.contactRoleId;
      }
    }

    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
      payload: {
        savedDataBeforeRedirecting: {
          dataToBeSaved: dataToBeSaved,
          contractRoleId: contactRoleId,
          indexForAdditionalPerson: indexForAdditionalPerson
        }
      }
    });
  }

  public renderNotificationDateQuicksets = () => {
    return (
      <div className="date-quickset-wrapper">
        <div
          className="date-quickset"
          onClick={() => {
            if (this.state.isReadonly || this.state.removed) {
              return;
            }

            this.selectDate(Time.useSetForExpirationDate(this.state.firstDate, 6), "lastDate");
          }}
        >
          6
        </div>
        <div
          className="date-quickset"
          onClick={() => {
            if (this.state.isReadonly || this.state.removed) {
              return;
            }

            this.selectDate(Time.useSetForExpirationDate(this.state.firstDate, 12), "lastDate");
          }}
        >
          12
        </div>
        <div
          className="date-quickset"
          onClick={() => {
            if (this.state.isReadonly || this.state.removed) {
              return;
            }

            this.selectDate(Time.useSetForExpirationDate(this.state.firstDate, 24), "lastDate");
          }}
        >
          24
        </div>
      </div>
    );
  }

  public renderExpirationDateQuicksets = () => {
    return (
      <div className="date-quickset-wrapper">
        <div
          className="date-quickset"
          onClick={() => {
            if (this.state.isReadonly || this.state.removed) {
              return;
            }

            this.selectDate(Time.substractMonth(this.state.lastDate, 1), "expirationDate")
          }}
        >
          1
        </div>
        <div
          className="date-quickset"
          onClick={() => {
            if (this.state.isReadonly || this.state.removed) {
              return;
            }

            this.selectDate(Time.substractMonth(this.state.lastDate, 2), "expirationDate")
          }}
        >
          2
        </div>
        <div
          className="date-quickset"
          onClick={() => {
            if (this.state.isReadonly || this.state.removed) {
              return;
            }

            this.selectDate(Time.substractMonth(this.state.lastDate, 4), "expirationDate")
          }}
        >
          4
        </div>
      </div>
    );
  }

  public selectTenant = (entity: CompanyInterface | PersonInterface, fromCoach: boolean): void => {

    this.setState({
      selectedTenant: entity,
      ignoredPeople: entity instanceof Person ? [entity, ...this.state.ignoredPeople] : [...this.state.ignoredPeople],
      hasModifiedData: true,
      openCoachCreateNewTenant: (entity instanceof Company && !entity?.generalContactId && !fromCoach) ? true : false,
      chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        let contactId = chargeTemplate?.contactId;
        let companyId = chargeTemplate?.companyId;

        if (entity instanceof Person) {
          if (entity?.id) {
            contactId = entity?.id;
            companyId = null;
          }
        }

        if (entity instanceof Company) {
          if (entity?.id) {
            companyId = entity?.id;
            contactId = null;
          }
        }

        return chargeTemplate.reinitialize({
          ...chargeTemplate,
          contactId: contactId,
          companyId: companyId
        });
      })
    });
  }

  public clearTenant = (): void => {
    this.setState({
      selectedTenant: null,
      hasModifiedData: true,
      chargeTemplates: this.state.chargeTemplates.map((chargeTemplate: ChargeTemplateInterface) => {
        let contactId = chargeTemplate?.contactId;
        let companyId = chargeTemplate?.companyId;

        if (this.state.selectedTenant instanceof Person) {
          if ((this.state.selectedTenant?.id && chargeTemplate?.contactId && this.state.selectedTenant?.id === chargeTemplate?.contactId)) {
            contactId = null;
            companyId = null;
          }
        }

        if (this.state.selectedTenant instanceof Company) {
          if ((this.state.selectedTenant?.id && chargeTemplate?.companyId && this.state.selectedTenant?.id === chargeTemplate?.companyId)) {
            companyId = null;
            contactId = null;
          }
        }

        return chargeTemplate.reinitialize({
          ...chargeTemplate,
          contactId: contactId,
          companyId: companyId
        });
      })
    });
  }

  public changeIsCommercial = () => {
    this.setState({
      isCommercial: !this.state.isCommercial
    });
  }

  public changeIsCommercialFromSwitcher = () => {
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CONTRACT_IS_COMMERCIAL_UPDATE_START,
      payload: {
        contractId: this.state.contract?.id,
        isCommercial: !this.state.isCommercial
      },
      onSuccess: () => {
        this.setState({
          isCommercial: !this.state.isCommercial,
          isSaving: false
        });
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public changeAutoSendInvoiceToTenant = () => {
    if (this.state.contract?.isConcept) {
      return this.setState({
        autoSendInvoiceToTenant: !this.state.autoSendInvoiceToTenant,
        hasModifiedData: true
      });
    }

    if (!this.state.contract?.tenant?.email) {
      if (!this.state.autoSendInvoiceToTenant &&
        this.state.contract?.tenant instanceof Person ||
        (this.state.contract?.tenant instanceof Company &&
          !this.state.contract?.tenant?.generalContact?.email)
      ) {
        return this.setState({
          showTenantEmailPopup: true
        })
      }
    }

    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_START,
      payload: {
        contractId: this.state.contract?.id,
        autoSendInvoiceToTenant: !this.state.autoSendInvoiceToTenant,
        addressForRentEmail: this.state.addressForRentEmail
      },
      onSuccess: () => {
        this.setState({
          autoSendInvoiceToTenant: !this.state.autoSendInvoiceToTenant,
          isSaving: false
        });
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public changeAddressForRentEmail = () => {

    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CONTRACT_AUTO_SEND_INVOICE_TO_TENANT_UPDATE_START,
      payload: {
        contractId: this.state.contract?.id,
        autoSendInvoiceToTenant: this.state.autoSendInvoiceToTenant,
        addressForRentEmail: this.state.addressForRentEmail
      },
      onSuccess: () => {
        this.setState({
          autoSendInvoiceToTenant: this.state.autoSendInvoiceToTenant,
          addressForRentEmail: this.state.addressForRentEmail,
          isSaving: false
        });
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public renderInfoTab = () => {
    const previousContract: ContractInterface =
      this.state.contract && this.state.contract.previousContractId &&
      this.props.app.contracts.find((contract: ContractInterface) => contract.id === this.state.contract.previousContractId);

    return (
      <div>
        <div className="component" style={{ boxShadow: "0 3px 6px 0 rgb(0 0 0 / 10%)" }}>

          <ContractCard
            {...this.props}
            key={`contractcard-${this.state.contract?.id}`}
            contract={this.state.contract}
            reminders={this.props.notifications?.filter(n => n.removed === false)}
            mainCardPresentation={true}
            openedByDefault={true}
            switchIsPaidDirectlyToOwner={this.switchIsPaidDirectlyToOwner}
            isPaidDirectlyToOwner={this.state.isPaidDirectlyToOwner}
            switcher={true}
            handleAutoSendInvoiceToTenantSwitch={this.changeAutoSendInvoiceToTenant}
            handleVATSwitcher={this.changeIsCommercialFromSwitcher}
            openExpirationContractDialog={this.openExpirationContractDialog}
            fetchEntityEvents={this.fetchEntityEvents}
            openChangeEmailDialogOpen={this.openChangeEmailDialogOpen}
            editableFields={
              <div className="no-margins has-margin-bottom">

                <Card className="card">
                  <form>
                    {
                      !!previousContract && (
                        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-end", marginBottom: "5px", position: "relative" as "relative" }}>
                          <div style={{ display: "flex", color: "rgba(0, 0, 0, 0.6)" }}>
                            <div style={{ fontSize: "14px", color: "gray" }}>
                              {this.trans("textfield-previous-contract")}
                            </div>
                            <div style={{ paddingLeft: "5px" }} className="link-to-entity" onClick={() => this.redirect(`/app/contract/update/${previousContract.id}`)}>
                              {`  ${previousContract.displayName}`}
                            </div>
                          </div>
                        </div>
                      )
                    }

                    {
                      this.state.isReadonly && (
                        <div style={{ color: "#00BCD4", fontSize: "14px", margin: "0 0 5px 0" }}>
                          <span
                            className="list-label readonly"
                            style={{ marginRight: "5px" }}
                          >
                            {this.trans("label-readonly")}
                          </span>
                          {this.trans("page/contracts-hint/readonly")}
                        </div>
                      )}

                    {/* use this when open contract from tenant details page */}
                    {/* {(this.disableUnitId === 0 && !this.state.isReadonly) && ( */}
                    <div style={{ margin: "-10px 0px -20px 0" }}>
                      <UnitLookup
                        {...this.props}
                        id="unitId"
                        name="unitId"
                        className="scroll-to-unitId"
                        ref="UnitLookup"
                        floatingLabelText={this.trans("dropdown-searchforunit-label")}
                        autoSelectId={this.state.selectedUnit?.id}
                        disabled={this.disableUnitId !== 0 || this.state.isReadonly}
                        onSelect={this.selectUnit}
                        onClear={this.clearUnit}
                        fullUnitName={true}
                        forceUpdatePage={true}
                        saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect}
                        error={!!this.getErrorFor("unitId")}
                        width="100%"
                        containerWidth="60%"
                      />
                    </div>
                    {/* )} */}

                    {/* use this when open contract from unit details page */}
                    {/* {this.disablePersonId === 0 && ( */}
                    <div style={{ margin: "-14px 0" }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="search-bar-container" style={{ width: "60%" }}>
                          <Searchbar
                            {...this.props}
                            name="personId"
                            className="scroll-to-mainTenantContactId"
                            id="selectedTenantForContract"
                            ref="TenantLookup"
                            floatingLabelText={this.trans("label-tenant")}
                            allResults={true}
                            objectField={true}
                            onChange={this.selectTenant}
                            onClear={this.clearTenant}
                            selectedEntity={this.state.selectedTenant}
                            searchParameter={"contactsSearch"}
                            error={this.getErrorFor("mainTenantContactId") || this.getErrorFor("contactForContracts[0].contactId")}
                            disabled={this.disablePersonId !== 0 || this.state.canSelectTenant === false || this.state.isReadonly || this.state.removed}
                            showClickThroughLink={!this.props.dialogPresentation}
                            searchText={this.state.selectedTenant ? `${this.state.selectedTenant.nameOfEntity}, ${this.state.selectedTenant.displayName}` : null}
                            styleInModal={"pick-object-modal"}
                            createButton={"dropdown-button/newtenant"}
                            openCoachCreateNewEntity={() => {
                              this.setState({
                                openCoachCreateNewTenant: true,
                                selectedTenant: null
                              })
                            }
                            }
                          />
                        </div>

                        <TextField
                          className="form-element"
                          style={{ width: "30%", boxSizing: "border-box", marginLeft: "45px" }}
                          type="text"
                          label={this.trans("label-description")}
                          value={this.trans("label-tenant")}
                          variant="standard"
                          disabled={true}
                          error={false}
                        />
                      </div>
                    </div>
                    {/* )} */}

                    {this.renderAdditionalFields()}

                    {this.state.selectedTenant && this.state.isReadonly === false && (
                      <div style={{ margin: "10px 0 0 0" }}>
                        <Button
                          color="primary"
                          style={{
                            width: "60%",
                            boxSizing: "border-box",
                            border: "1px solid rgba(0,0,0,.1)",
                            marginLeft: "0px"
                          }}
                          className="plus-button"
                          onClick={this.addAdditionalFields}
                          disabled={this.state.isReadonly || this.state.removed}
                        >
                          {this.trans("contract-update-button-add-person-to-contract")}
                        </Button>
                      </div>
                    )}

                    <DatePickerComponent
                      {...this.props}
                      id="firstDate"
                      name="firstDate"
                      className="scroll-to-firstDate"
                      label={this.trans("first-date")}
                      initialDate={this.state.firstDate}
                      onChange={date => this.selectDate(date, "firstDate")}
                      disabled={this.state.isReadonly || this.state.removed}
                      clearButton={true}
                      width="60%"
                      datepickerMargin={true}
                      error={this.getErrorFor("firstDate")}
                      margin={"10px 0px 0px 0px"}
                    />

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className="wrapper-for-field" style={{ width: "60%" }}>
                        <DatePickerComponent
                          {...this.props}
                          id="lastDate"
                          name="lastDate"
                          className="scroll-to-lastDate"
                          label={this.trans("expiration-date") + " 1" + Time.getDatepickerHint() + this.trans("field/optional")}
                          initialDate={this.state.lastDate}
                          onChange={date => this.selectDate(date, "lastDate")}
                          minDate={this.state.firstDate}
                          minDatePlusDays={1}
                          minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                          hint={this.state.datepickerHint}
                          clearButton={true}
                          datepickerMargin={true}
                          disabled={this.state.isReadonly || this.state.removed}
                          error={this.state.datepickerError}
                          margin={"7px 0px 0px 0px"}
                        />
                        <div className={`block-tooltip ${this.state.tooltipOpen ? 'open-tooltip' : 'close-tooltip'}`} onClick={this.openTooltip}>
                          <div id="tooltip-block" className="tooltip-icon">?</div>
                          <span id="hidden-hint" className="hidden">{this.trans("page/contracts-hint/lastdate-info")}</span>
                        </div>
                      </div>
                      {this.renderNotificationDateQuicksets()}
                    </div>

                    <DatePickerComponent
                      {...this.props}
                      id="finalDate"
                      name="finalDate"
                      className="scroll-to-finalRentalPeriodDate"
                      label={this.trans("expiration-date") + " 2" + Time.getDatepickerHint() + this.trans("field/optional")}
                      initialDate={this.state.finalRentalPeriodDate}
                      onChange={date => this.selectDate(date, "finalRentalPeriodDate")}
                      minDate={this.state.firstDate}
                      minDatePlusDays={1}
                      minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                      clearButton={true}
                      disabled={this.state.isReadonly || this.state.removed}
                      width="60%"
                      datepickerMargin={true}
                      error={this.getErrorFor("finalRentalPeriodDate")}
                      margin={"7px 0px 0px 0px"}
                    />

                    {this.state.notifications[0] && this.state.contract.isConcept && (
                      <div style={{ display: "flex" }}>
                        <DatePickerComponent
                          {...this.props}
                          id="expirationDate"
                          name="expirationDate"
                          className="scroll-to-expirationDate"
                          label={this.trans("contract-expiration-date") + this.trans("field/optional")}
                          initialDate={this.state.firstNotificationDate}
                          value={this.state.firstNotificationDate}
                          minDate={new Date()}
                          minDatePlusDays={0}
                          onChange={date => this.selectDate(date, "firstNotificationDate")}
                          clearButton={true}
                          width="60%"
                          datepickerMargin={true}
                          disabled={this.state.removed}
                          error={this.state.firstNotificationText && !this.state.firstNotificationDate}
                          margin={"7px 0px 0px 0px"}
                        />
                        {/* {this.renderExpirationDateQuicksets()} */}
                        <TextField
                          type="text"
                          value={this.state.firstNotificationText}
                          onChange={(e) => this.setState({ firstNotificationText: e.target.value, hasModifiedData: true, notificationWasModified: true })}
                          style={{ width: "40%", boxSizing: "border-box", margin: "7px 0px 0px 10px" }}
                          label={this.trans("dialog-new-notification-text")}
                          error={!this.state.firstNotificationText && this.state.firstNotificationDate}
                        />
                      </div>
                    )}
                    {this.state.notifications[1] && this.state.contract.isConcept && (
                      <div style={{ display: "flex" }}>
                        <DatePickerComponent
                          {...this.props}
                          id="expirationDate"
                          name="expirationDate"
                          className="scroll-to-expirationDate"
                          label={this.trans("contract-expiration-date") + this.trans("field/optional")}
                          initialDate={this.state.secondNotificationDate}
                          value={this.state.secondNotificationDate}
                          minDate={new Date()}
                          minDatePlusDays={0}
                          onChange={date => this.selectDate(date, "secondNotificationDate")}
                          clearButton={true}
                          width="60%"
                          datepickerMargin={true}
                          disabled={this.state.removed}
                          error={this.state.secondNotificationText && !this.state.secondNotificationDate}
                          margin={"7px 0px 0px 0px"}
                        />
                        {/* {this.renderExpirationDateQuicksets()} */}
                        <TextField
                          type="text"
                          value={this.state.secondNotificationText}
                          onChange={(e) => this.setState({ secondNotificationText: e.target.value, hasModifiedData: true, notificationWasModified: true })}
                          style={{ width: "40%", boxSizing: "border-box", margin: "7px 0px 0px 10px" }}
                          label={this.trans("dialog-new-notification-text")}
                          error={!this.state.secondNotificationText && this.state.secondNotificationDate}
                        />
                      </div>
                    )}

                    {this.state.contract && !this.state.contract.isConcept && (
                      <React.Fragment>
                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                          <DatePickerComponent
                            {...this.props}
                            name="expirationDate"
                            className="scroll-to-expirationDate"
                            onChange={date => this.selectDate(date, "expirationDate")}
                            label={
                              this.state.expirationDate ? this.trans("contract-expiration-date") : this.trans("label-expiration-date-not-set")
                            }
                            initialDate={this.state.expirationDate}
                            value={this.state.expirationDate}
                            clearButton={true}
                            width="60%"
                            disabled={true}
                            datepickerMargin={true}
                            error={this.getErrorFor("expirationDate")}
                            margin={"7px 0px 0px 0px"}
                          />
                          <TextField
                            type="text"
                            value={this.state.rentNotificationText}
                            onChange={(e) => this.setState({ rentNotificationText: e.target.value, hasModifiedData: true })}

                            style={{ width: "30%", boxSizing: "border-box", marginLeft: "45px" }}
                            label={this.trans("dialog-new-notification-text")}
                          />
                          <Button
                            color="primary"
                            onClick={this.openExpirationContractDialog}
                            style={{ marginLeft: "20px", color: "#00BCD4", border: "1px solid rgba(0, 0, 0, 0.1)" }}
                            disabled={(this.state.contract && this.state.contract.isDropped) || this.state.removed}
                          >
                            {!!this.state.expirationDate ? this.trans("change-warning-date") : this.trans("set-warning-date")}
                          </Button>
                        </div>
                        <div className="hint-styles">
                          {this.trans("hint/contractexpirationdate")}
                        </div>
                      </React.Fragment>
                    )}

                    {this.state.contract && !this.state.contract.isConcept && !!this.state.endDate && (
                      <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "baseline" }}>
                        <DatePickerComponent
                          {...this.props}
                          id="endDate"
                          name="endDate"
                          className="scroll-to-endDate"
                          label={this.state.endDate ? this.trans("end-date") + this.trans("field/optional") : this.trans("end-date-not-set") + this.trans("field/optional")}
                          initialDate={this.state.endDate}
                          value={this.state.endDate}
                          clearButton={true}
                          width="60%"
                          disabled={true}
                          datepickerMargin={true}
                          error={this.getErrorFor("endDate")}
                          margin={"7px 0px -5px 0px"}
                        />
                      </div>
                    )}

                    <div style={{ width: "60%", marginTop: "-5px" }}>
                      <TextField
                        autoComplete="off"
                        id="note"
                        name="note"
                        className="form-element full-size scroll-to-note"
                        type="text"
                        multiline={true}
                        rowsMax={10}
                        label={this.trans("note") + this.trans("field/optional")}
                        value={this.state.note}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                        variant="standard"
                        disabled={this.state.isReadonly || this.state.removed}
                        error={!!this.getErrorFor("note")}
                        helperText={this.getErrorFor("note")}
                      />
                    </div>

                    <div style={{ marginTop: "-10px" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.isCommercial}
                            onChange={this.changeIsCommercial}
                            color="primary"
                          />
                        }
                        label={this.trans("page/contracts-label/iscommercialcontract", { vatPercentage: this.props?.app?.settings?.agency?.vatPercentage })}
                      />
                    </div>

                    <div style={{ paddingBottom: "20px" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.autoSendInvoiceToTenant}
                            onChange={this.changeAutoSendInvoiceToTenant}
                            color="primary"
                          />
                        }
                        label={this.trans("page/contracts-label/automaticallysendrentinvoice")}
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.isPaidDirectlyToOwner}
                            onChange={this.switchIsPaidDirectlyToOwner}
                            color="primary"
                          />
                        }
                        label={this.trans("coach/newcontract-step/paiddirectlytoowner-label")}
                      />
                    </div>
                  </form>
                </Card>
              </div>
            }
          />
        </div>
        <div className="component-wrapper no-margins has-margin-bottom has-margin-top no-shadow">
          <Card className="card no-padding">
            <div>
              {
                this.state.chargeTemplates
                  .map((chargeTemplate: ChargeTemplateInterface) => {
                    return (
                      <div className="component-wrapper no-margins has-margin-bottom">
                        <div className="component">
                          <ChargeTemplateCard
                            key={`chargeTemplate-${chargeTemplate?.id}`}
                            chargeTemplate={chargeTemplate}
                            openChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate }, () => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate))}
                            removeChargeTemplate={() => this.setState({ selectedChargeTemplate: chargeTemplate }, () => this.deleteChargeTemplate(this.state.selectedChargeTemplate))}
                          />
                        </div>
                      </div>
                    );
                  })
              }
            </div>
          </Card>
        </div>

        <div className="component-wrapper no-margins">
          <Attachment
            {...this.props}
            typeOfComponent="shared"
            title={this.trans("attachments-for-contract")}
            amazonFolderName={this.state.amazonFolderName}
            relation="contractId"
            entity={this.state.contract}
            attachments={this.state.attachments}
            updateParentState={attachments => this.setState({ attachments: attachments })}
            onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
            onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
            disabled={this.state.removed}
          />
        </div>
      </div>
    );
  }

  public renderFinanceTab = () => {
    const occupants = this.state.contract && this.state.contract.occupants && this.state.contract.occupants.map(occupant => {
      return `${occupant.person.firstName} ${occupant.person.lastName}`
    })

    return (
      <div className="component-wrapper no-margins has-margin-bottom">
        <Card className="card no-padding">
          <div className="label-container">
            <h3 className="card-title">
              {this.trans("balance-for-contract")}
            </h3>

            <p style={{
              marginLeft: "65px",
              fontSize: "12px",
              marginTop: "-10px",
              color: "gray"
            }}>
              {`${this.trans("role-tenant")}: `}{this.state.contract?.tenantDisplayName ? this.state.contract?.tenantDisplayName : ""}{!!occupants && occupants.length > 0 && (<span style={{ fontSize: "12px", marginLeft: "7px" }}>{`(${this.trans("role-mede-huurder")}: `}{occupants.join(", ")}{")"}</span>)}
            </p>

            <Button
              color="primary"
              onClick={() => {
                if (this.checkProcessIsBusy({
                  action: "create",
                  entityName: "charge",
                  entity: this.state.contract
                })) {
                  this.openIsBusyPopup();
                } else {
                  if (this.state.contract && this.state.contract.isConcept) {
                    this.props.dispatch({
                      type: Constants.SNACKBAR_ADD_MESSAGE,
                      payload: {
                        message: this.trans("sign-the-contract-to-create-charges"),
                        type: "warning"
                      }
                    });
                  } else {
                    this.props.dispatch({
                      type: Constants.PAGE_CHARGE_CREATE_ADD_PARAMS,
                      payload: {
                        contractId: this.state.contract && this.state.contract.id
                      }
                    });

                    this.openChargeCreatePopup();
                  }
                }
              }}
              disabled={this.state.removed}
            >
              {this.trans("button-add-charge")}
            </Button>
          </div>

          <BalanceComponent
            {...this.props}
            balanceFor="contract"
            balanceCharges={this.state.charges}
            deleteCharge={this.deleteCharge}
            fetchCharges={() => {
              this.fetchContractCharges(this.state.contract && this.state.contract.id);
            }}
            contractId={this.state.contract && this.state.contract.id}
            contract={this.state.contract && this.state.contract}
          />
        </Card>
      </div>
    );
  }

  public deleteCharge = (charge: ChargeInterface): any => {
    if (charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_withdraw") || charge?.type?.id === TypeContainer.pickIdFromLabel("Savings_account_deposit")) {
      return this.setState({
        isChargeRemovePopupOpen: false,
        cannotDeleteSavingsChargeDialog: true
      });
    }

    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_DELETE_START,
        payload: {
          charge: charge
        },
        onSuccess: res => {
          this.fetchContractCharges(this.state.contract && this.state.contract.id);

          this.setState({
            deletedCharge: charge,
            removedPayments: res.data.data.removedPayments,
            paymentsFailedToRemove: res.data.data.paymentsFailedToRemove,
            isSaving: false
          }, () => {
            if (this.state.deletedCharge && this.state.deletedCharge.amountPaid > 0 && (!!this.state.removedPayments && this.state.removedPayments.length === 0)) {
              this.props.dispatch({
                type: Constants.SNACKBAR_ADD_MESSAGE,
                payload: {
                  message: this.trans("textfield-charge-was-deleted-you-can-find-payments"),
                  type: "info"
                }
              });
            }
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          })
        }
      });
    });
  }

  public fetchContractCharges = (contractId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        contractId: contractId,
        isAfterStartDate: 1, // do not fetch charges before start date
      },
      onSuccess: data => {
        this.setState({ charges: [...data.charges] });
      }
    });
  }

  public openAgencyFeeDialog = () => {
    return this.setState({
      isAgencyFeeDialogOpen: true
    });
  }

  public closeAgencyFeeDialog = () => {

    // sending empty error array to clear page errors
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
      payload: {
        err: []
      }
    });

    this.cancelSigningProcess();

    this.setState({
      isAgencyFeeDialogOpen: false,
      isAgencyFeeСreatePopupOpen: false,
      isUpdating: false
    });
  }

  public addAgencyFee = (agencyFee): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.closeAgencyFeeDialog();
      }
    });
  }

  public addAgencyFeeFromSignProcessDialog = (agencyFee): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_START,
      payload: agencyFee,
      onSuccess: () => {
        // sending empty error array to clear page errors
        this.props.dispatch({
          type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
          payload: {
            err: []
          }
        });

        this.setState({
          isAgencyFeeDialogOpen: false,
          isAgencyFeeСreatePopupOpen: false,
          isUpdating: false,
        }, this.save);

      }
    });
  }

  public updateAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    if (this.state.contract && this.state.contract.isReadonly) {
      this.setState({
        anchorElAgencyFees: null
      })

      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("you-can-not-update-charge-templates-for-active-contract"),
          type: "warning"
        }
      });
    }

    this.setState({
      selectedAgencyFee: agencyFee,
      isUpdating: true,
      anchorElAgencyFees: null
    }, () => {
      this.openAgencyFeeDialog();
    });
  }

  public saveAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_UPDATE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.closeAgencyFeeDialog();
      }
    });
  }

  public deleteAgencyFee = () => {
    this.closeMenuAgencyFees();

    const agencyFee = this.state.agencyFee;

    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_DELETE_START,
      payload: agencyFee,
      onSuccess: () => {
        this.setState({ isAgencyRemoveDialog: false, agencyFee: null });
      },
      onError: () => {
        this.setState({
          isAgencyRemoveDialog: false,
          agencyFee: null
        });
      }
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isAgencyRemoveDialog: false,
    })
  }

  protected openMenuAgencyFees = (event: any, agencyFee: AgencyFeeInterface): void => {
    this.setState({
      selectedAgencyFee: agencyFee,
      anchorElAgencyFees: event.currentTarget
    });
  }

  protected closeMenuAgencyFees = (): void => {
    this.setState({
      anchorElAgencyFees: null
    });
  }

  public getDefaultAgencyFees = () => {
    return this.state.contract && this.state.contract.defaultAgencyFees && this.state.contract.defaultAgencyFees.map((agencyFee: AgencyFeeInterface) => {
      return (
        <TableRow
          hover
          key={agencyFee.id}
          className={`clickable-entity`}
          onClick={() => {
            this.updateAgencyFee(agencyFee);
          }}
        >
          <TableCell>
          </TableCell>
          <TableCell style={{ width: "30%" }}>
            {this.formatter.formatNumber(agencyFee.fixedFee, agencyFee.currency)}
          </TableCell>
          <TableCell style={{ width: "30%" }}>{`${this.formatter.simpleFormatNumber(agencyFee.percentageFee, false)}%`}</TableCell>
          <TableCell style={{ width: "35%" }}>{Formatter.checkTranslationType(this.trans(agencyFee.fixedPlusPercentageMode.label), agencyFee.fixedPlusPercentageMode.label)}</TableCell>
          <TableCell
            style={{ width: "5%" }}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div>
              <IconButton
                onClick={e => this.openMenuAgencyFees(e, agencyFee)}
              >
                <div className="icon icon-ic-more-vert"></div>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorElAgencyFees}
                open={Boolean(this.state.anchorElAgencyFees) && this.state.selectedAgencyFee?.id === agencyFee.id}
                onClose={this.closeMenuAgencyFees}
                disableAutoFocusItem={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left"
                }}
                getContentAnchorEl={null}
              >
                <MenuItem
                  onClick={() => {
                    this.closeMenuAgencyFees();

                    this.updateAgencyFee(this.state.selectedAgencyFee)
                  }}
                >
                  <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                </MenuItem>
                <MenuItem
                  className="delete-action"
                  onClick={() => {
                    this.closeMenuAgencyFees();

                    if (this.state.contract && this.state.contract.isReadonly) {
                      return this.props.dispatch({
                        type: Constants.SNACKBAR_ADD_MESSAGE,
                        payload: {
                          message: this.trans("you-can-not-update-charge-templates-for-active-contract"),
                          type: "warning"
                        }
                      });
                    }

                    this.setState({ agencyFee: this.state.selectedAgencyFee, isAgencyRemoveDialog: true })
                  }}
                >
                  <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }

  public getAgencyFeeDialogTitle = (): string => {
    return this.trans("dialog/agencyfee-title");
  }

  public doIntervalTickForRemoveButton = () => {
    clearInterval(this.timerId);
    if (this.state.intervalTickForRemoveButton === 1) {
      this.setState({
        isRemoveButtonDisabled: false,
        labelForRemoveButton: this.trans("button-remove")
      })
    } else {
      this.setState({
        intervalTickForRemoveButton: this.state.intervalTickForRemoveButton - 1,
        labelForRemoveButton: this.trans("button-remove") + ` (${this.state.intervalTickForRemoveButton - 1}s)`
      }, () => {
        this.timerId = setInterval(() => {
          this.doIntervalTickForRemoveButton()
        }, 1000);
      });
    }
  }

  public openDeleteContractDialog = (contract: ContractInterface): any => {
    this.setState({
      contractToDelete: contract,
      anchorEl: null,
      intervalTickForRemoveButton: 5,
      isRemoveButtonDisabled: true,
      labelForRemoveButton: this.trans("button-remove") + ` (${this.state.intervalTickForRemoveButton}s)`
    }, () => this.setState({
      isDoYouWantToDeleteContractDialogOpen: true,
    }, () => {
      this.timerId = setInterval(() => {
        this.doIntervalTickForRemoveButton()
      }, 1000);
    })
    )
  }

  public closeDeleteContractDialog = (): any => {
    clearInterval(this.timerId);
    this.setState({
      isDoYouWantToDeleteContractDialogOpen: false,
      isRemoveButtonDisabled: true,
      intervalTickForRemoveButton: 5
    });
  }

  public deleteContract = (contract: ContractInterface): any => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CONTRACT_DELETE_START,
        payload: {
          contract: contract
        },
        onSuccess: () => {
          this.closeDeleteContractDialog();

          this.setState({
            isSaving: false
          })

          this.props.dispatch({
            type: Constants.SNACKBAR_ADD_MESSAGE,
            payload: {
              message: this.state.contract && (this.state.contract.isConcept || this.state.contract.isDropped) ?
                this.trans("dialog/postprocess-removenotsignedcontract") :
                this.trans("dialog/postprocess-removesignedcontract"),
              type: "info"
            }
          });

          this.redirectBack();
        },
        onError: () => {
          this.setState({
            isSaving: false
          })
        },
      });
    });
  }

  protected openMenu = (event: any, contract: ContractInterface): void => {
    this.setState({
      contract: contract,
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public checkPeriodForCreateChargesNextMounthDialog = () => {
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_GET_PERIOD_START,
      payload: {
        contractId: this.state?.contract?.id
      },
      onSuccess: (data) => {
        if (typeof data?.period === "string") {
          this.setState({
            createChargesForNextPeriodDialogOpen: true,
            nextPeriodForCharges: data?.period
          });
        }
        this.setState({
          isSaving: false
        });
      },
      onError: () => {
        this.setState({
          isSaving: false,
          settleSavingScenarioMessage: "it_is_not_possible_to_make_savings_action"
        });
      }
    });
  }

  public createChargesForNextMounth = () => {
    this.setState({
      isSaving: true
    });

    this.props.dispatch({
      type: Constants.GLOBAL_CREATE_CHARGES_FOR_NEXT_MOUNTH_START,
      payload: {
        contractId: this.state?.contract?.id
      },
      onSuccess: () => {
        this.props.dispatch({
          type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
        });

        this.setState({
          isSaving: false
        });

        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("snackbar-message-charges-for-next-mounth-create-successfully"),
            type: "success"
          }
        });

        return this.initializePage(this.state.contract);
      },
      onError: () => {
        this.setState({
          isSaving: false,
        });
      }
    });
  }


  public openCollectiveInvoiceCoachDialog = () => {
    this.setState({
      openCreateCollectiveInvoiceCoachOpen: false,
    })
  }

  public onCloseCollectiveInvoiceCoach = () => {
    this.setState({
      isCreateCollectiveInvoiceCoachOpen: false,
      isPreProcessCreateCollectiveInvoiceCoachOpen: false
    })
  }

  public startSendingProcess = () => {
    return this.redirect(`/app/email/send/contract/${this.state.contract?.id}?&firstInvoice=${this.state.typeOfCollectiveInvoice === "first" ? true : false}`);
  }

  public startPrintingProcess = () => {
    if (this.state.invoicePdfUrl) {
      window.open(CasedeskUrl.getAttachment(this.state.invoicePdfUrl), "_blank");
    }
  }

  public openChargeCreatePopup = () => {
    this.setState({
      // isChargeCreatePopupOpen: true,
      isCoachNewChargeOpen: true
    });
  }

  public closeChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: false,
      openChargeCreatePopupLaunchPanel: false
    });
  }


  public unactive(event) {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: event,
      },
      onSuccess: () => {
        this.fetchEntityEvents(this.state.contract?.id);
        // this.props.dispatch({
        //   type: Constants.GLOBAL_CONVERSATION_READ_UPDATE_START,
        //   payload: {
        //     conversationId: this.props.app.conversations?.find(c => c.eventId === event.id)?.id
        //   }
        // });
      },
      onError: () => {
        this.setState({
          isSaving: false
        });
      }
    });
  }

  public createPdf = (callback = () => { }) => {
    this.setState({
      isCreatePdfPopupOpen: false
    });
    this.saving(() => {
      this.props.dispatch({
        type: Constants.CONTRACT_PDF_CREATE_START,
        payload: {
          contractId: this.state.contract?.id,
          lngId: this.state.contract?.tenant?.languageTypeId ? this.state.contract?.tenant?.languageTypeId : 1,
        },
        onSuccess: () => {
          this.setState({
            isSaving: false,
            attachments: this.state.contract.attachments
          }, callback);
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    })
  }

  public render() {

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button two-row-title">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div className="title-wrapper">
                <h1>{`${this.trans("textfield-contract")} - `}
                  <span style={{ color: this.state.contract && this.state.contract.getStatusColor() }}>{this.trans(this.state.contract && this.state.contract.contractStatus).toLowerCase()}</span></h1>
              </div>

              <div className="button-container">
                {this.state.contract && this.state.contract.isConcept && (
                  <Button
                    color="primary"
                    onClick={() => {
                      if (this.checkProcessIsBusy({
                        action: "sign",
                        entityName: "contract",
                        entity: this.state.contract
                      })) {
                        this.openIsBusyPopup();
                      } else {
                        this.setState({ isSigningProcess: true }, this.save);
                      }
                    }}
                    variant="outlined"
                    disabled={this.state.removed}
                  >
                    {this.trans("sign")}
                  </Button>
                )}
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={this.redirectBack}
                      disabled={this.state.removed}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                  )
                }
                <Button
                  color="primary"
                  onClick={this.state.hasModifiedData ? this.save : this.done}
                  variant="contained"
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("button-save") : this.trans("label-done")}
                </Button>
              </div>
            </div>
            <div className="inner-wrapper" style={{ flexDirection: "column", alignItems: "flex-start" }}>
              <h4>{this.state.contract ? this.state.contract.displayName : ""}</h4>
            </div>
          </div>

          <div className="box component-contract-update">
            {
              !this.state.contract?.isConcept && this.state.notifications?.length > 0 && this.state.notifications.filter(n => Time.todayOrEarlier(n.remindDate) && n.removed === false)
                .sort((notification1: EventInterface, notification2: EventInterface) => {
                  if (notification1.remindDate < notification2.remindDate) {
                    return 1;
                  }

                  if (notification1.remindDate > notification2.remindDate) {
                    return -1;
                  }

                  return 0;
                })
                .map((notification: EventInterface) => {
                  return (
                    <div className="component-wrapper no-margin-top">
                      <Card className="card" style={{ padding: "20px", backgroundColor: "#FDFFEC" }}>

                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                          <div style={{ display: "flex" }}>
                            <div className="icon icon-ic-info"></div>
                            <div style={{ marginLeft: "12px" }}>
                              {`${this.trans("notification")}: ${this.formatter.formatDate(notification.remindDate)} ${notification.content?.name}`}
                            </div>
                          </div>

                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.unactive(notification)}
                          >
                            {this.trans("notification-done")}
                          </Button>
                        </div>

                      </Card>

                    </div>
                    // <div className="component-wrapper no-margin-top has-margin-bottom">
                    //   <Card
                    //     style={{
                    //       boxShadow: "none"
                    //     }}
                    //   >
                    //     <CardContent style={{
                    //       display: "flex",
                    //       justifyContent: "space-between",
                    //       alignItems: "center",
                    //       padding: "8px 20px 0px 20px",
                    //     }}>
                    //       <div style={{ display: "flex", alignItems: "center" }}>
                    //         <img src={this.image.get("info")} alt="info" style={{ width: "30px", height: "30px" }} />
                    //         <h2 style={{ marginLeft: "15px", fontWeight: "normal" }}>{notification.content?.name}</h2>
                    //       </div>
                    //       <Button
                    //         variant="contained"
                    //         color="primary"
                    //         onClick={() => this.unactive(notification)}
                    //       >
                    //         {this.trans("menuitem-delete")}
                    //       </Button>
                    //     </CardContent>
                    //   </Card>
                    // </div>
                  );
                })
            }

            <div className="component-wrapper no-margin-top no-shadow">
              <Tabs
                className="tab tab-simple has-margin-bottom"
                value={this.state.selectedTabIndex}
                onChange={this.switchTab}
              >
                <Tab label={this.trans("label-overview")} value={0} />
                <Tab label={this.trans("label-finance")} value={1}
                  onClick={() => this.fetchContractCharges(this.state.contract && this.state.contract.id)}
                />
              </Tabs>


              {this.state.selectedTabIndex === 0 && this.renderInfoTab()}
              {this.state.selectedTabIndex === 1 && this.renderFinanceTab()}
            </div>
          </div>

          <div className={"right-panel-wrapper"}>
            {
              this.state.contract && (
                <EntityLaunchpanel
                  {...this.props}
                  entityTitle={this.trans("launchpanel-contract-title")}
                  panelWithMoreButton={{ borderBottom: 0 }}
                  actionsList={
                    <List component="div" disablePadding>
                      {
                        this.state.contract?.isConcept && (
                          <ListItem
                            button
                            alignItems="flex-start"
                            key="menuitem-create-charge-template"
                            onClick={() => {
                              const unit = this.props.units.byId[this.state.contract.unitId]
                              if (unit?.unitServiceStatus.label === "INACTIVE") {
                                this.props.dispatch({
                                  type: Constants.SNACKBAR_ADD_MESSAGE,
                                  payload: {
                                    message: this.trans("archived_unit"),
                                    type: "error"
                                  }
                                });
                              } else if (this.state.hasModifiedData) {
                                this.setState({
                                  isErrorLaunchPanelOpen: true,
                                  anchorEl: null,
                                  openLeavePrompt: true
                                })
                              } else {
                                this.openChargeTemplateCreatePopup();
                              }
                            }}
                            disabled={this.state.removed}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-charge"></div></ListItemIcon>
                            <ListItemText primary={this.trans("launchpanel/contract-option/createchargetemplate")} secondary={this.trans("launchpanel/contract-option/createchargetemplate-hint")} />
                          </ListItem>
                        )
                      }
                      {
                        this.state.contract?.isConcept &&
                        <>
                          <ListItem
                            button
                            alignItems="flex-start"
                            key="menuitem-drop"
                            onClick={() => {
                              if (this.checkProcessIsBusy({
                                action: "drop",
                                entityName: "contract",
                                entity: this.state.contract
                              })) {
                                this.openIsBusyPopup();
                                this.setState({ anchorEl: null });
                              } else if (this.state.hasModifiedData) {
                                this.setState({
                                  isErrorLaunchPanelOpen: true,
                                  anchorEl: null,
                                  openLeavePrompt: true
                                })
                              } else {
                                this.setDroppedStatus(this.state.contract)
                              }
                            }}
                            disabled={this.state.removed}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-drop"></div></ListItemIcon>
                            <ListItemText primary={this.trans("cancel-the-contract")} secondary={this.trans("hint/launch-panel-drop")} />
                          </ListItem>

                        </>

                      }
                      <ListItem
                        button
                        alignItems="flex-start"
                        key="menuitem-create-extra-charge"
                        onClick={() => {
                          const unit = this.props.units.byId[this.state.contract.unitId]
                          if (unit?.unitServiceStatus.label === "INACTIVE") {
                            this.props.dispatch({
                              type: Constants.SNACKBAR_ADD_MESSAGE,
                              payload: {
                                message: this.trans("archived_unit"),
                                type: "error"
                              }
                            });
                          } else if (this.checkProcessIsBusy({
                            action: "createInvoice",
                            entityName: "contract",
                            entity: this.state.contract
                          })) {
                            this.openIsBusyPopup();
                            this.setState({ anchorEl: null });
                          } else if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorEl: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.setState({ openChargeCreatePopupLaunchPanel: true, isCoachNewChargeOpen: true });
                          }
                        }}
                        disabled={this.state.removed}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-link"></div></ListItemIcon>
                        <ListItemText primary={this.trans("launchpanel-menuitem/createextracharge")} secondary={this.trans("hint/launch-panel-create-extra-charge")} />
                      </ListItem>
                      {
                        !this.state.contract?.isConcept && !this.state.contract?.isDropped && !this.state.contract?.isEnding && !this.state.contract?.endDate &&
                        <ListItem
                          button
                          alignItems="flex-start"
                          key="menuitem-set-end-date"
                          onClick={() => {
                            const unit = this.props.units.byId[this.state.contract.unitId]
                            if (unit?.unitServiceStatus.label === "INACTIVE") {
                              this.props.dispatch({
                                type: Constants.SNACKBAR_ADD_MESSAGE,
                                payload: {
                                  message: this.trans("archived_unit"),
                                  type: "error"
                                }
                              });
                            } else if (this.checkProcessIsBusy({
                              action: "end",
                              entityName: "contract",
                              entity: this.state.contract
                            })) {
                              this.openIsBusyPopup();
                              this.setState({ anchorEl: null });
                            } else if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorEl: null,
                                openLeavePrompt: true
                              })
                            } else {
                              this.openEndContractDialog()
                            }
                          }}
                          disabled={this.state.removed}
                          style={{ padding: "1px 16px" }}
                        >
                          <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-stop"></div></ListItemIcon>
                          <ListItemText primary={this.trans("set-end-date")} secondary={this.trans("hint/launch-panel-set-end-date-contract")} />
                        </ListItem>
                      }
                      {
                        this.state.contract?.endDate && (
                          <ListItem
                            button
                            alignItems="flex-start"
                            key="menuitem-clear-end-date"
                            onClick={() => {
                              const unit = this.props.units.byId[this.state.contract.unitId]
                              if (unit?.unitServiceStatus.label === "INACTIVE") {
                                this.props.dispatch({
                                  type: Constants.SNACKBAR_ADD_MESSAGE,
                                  payload: {
                                    message: this.trans("archived_unit"),
                                    type: "error"
                                  }
                                });
                              } else if (this.checkProcessIsBusy({
                                action: "end",
                                entityName: "contract",
                                entity: this.state.contract
                              })) {
                                this.openIsBusyPopup();
                                this.setState({ anchorEl: null });
                              } else if (this.state.hasModifiedData) {
                                this.setState({
                                  isErrorLaunchPanelOpen: true,
                                  anchorEl: null,
                                  openLeavePrompt: true
                                })
                              } else {
                                this.setState({ anchorEl: null }, () => this.clearEndDate(this.state.contract));
                              }
                            }}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-stop"></div></ListItemIcon>
                            <ListItemText primary={this.trans("menuitem-clear-end-date")} secondary={this.trans("hint/launch-panel-clear-end-date-contract")} />
                          </ListItem>
                        )
                      }
                      {
                        (this.state.contract?.isSigned || this.state.contract?.isExpiring) &&
                        <>
                          <ListItem
                            button
                            alignItems="flex-start"
                            key="menuitem-adjust"
                            onClick={() => {
                              const unit = this.props.units.byId[this.state.contract.unitId]
                              if (unit?.unitServiceStatus.label === "INACTIVE") {
                                this.props.dispatch({
                                  type: Constants.SNACKBAR_ADD_MESSAGE,
                                  payload: {
                                    message: this.trans("archived_unit"),
                                    type: "error"
                                  }
                                });
                              } else if (this.checkProcessIsBusy({
                                action: "adjust",
                                entityName: "contract",
                                entity: this.state.contract
                              })) {
                                this.openIsBusyPopup();
                                this.setState({ anchorEl: null });
                              } else if (this.state.hasModifiedData) {
                                this.setState({
                                  isErrorLaunchPanelOpen: true,
                                  anchorEl: null,
                                  openLeavePrompt: true
                                })
                              } else {
                                this.setState({ isAdjustRentCoachOpen: true, anchorEl: null })
                              }
                            }}
                            disabled={this.state.removed}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-extend"></div></ListItemIcon>
                            <ListItemText primary={this.trans("launchpanel/option-adjust")} secondary={this.trans("hint/launch-panel-adjust-contract")} />
                          </ListItem>


                          <ListItem
                            button
                            alignItems="flex-start"
                            key="menuitem-adjust"
                            onClick={() => {
                              if (!this.state.contract.previousContractId) {
                                this.props.dispatch({
                                  type: Constants.SNACKBAR_ADD_MESSAGE,
                                  payload: {
                                    message: this.trans("no_previous_contract"),
                                    type: "error"
                                  }
                                });
                              } else {
                                return this.redirect(`/app/email/send/new-contract/${this.state.contract?.id}`);
                              }
                            }}
                            disabled={this.state.removed}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-email"></div></ListItemIcon>
                            <ListItemText
                              primary={this.trans("launchpanel/send-adjust")}
                            // secondary={this.trans("hint/launch-panel-adjust-contract")} 
                            />
                          </ListItem>
                        </>
                      }
                      {
                        !this.state.contract?.endDate &&
                        <ListItem
                          button
                          alignItems="flex-start"
                          key="menuitem-create-first-invoice"
                          onClick={() => {
                            const unit = this.props.units.byId[this.state.contract.unitId]
                            if (unit?.unitServiceStatus.label === "INACTIVE") {
                              this.props.dispatch({
                                type: Constants.SNACKBAR_ADD_MESSAGE,
                                payload: {
                                  message: this.trans("archived_unit"),
                                  type: "error"
                                }
                              });
                            } else if (this.checkProcessIsBusy({
                              action: "createInvoice",
                              entityName: "contract",
                              entity: this.state.contract
                            })) {
                              this.openIsBusyPopup();
                              this.setState({ anchorEl: null });
                            } else if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorEl: null,
                                openLeavePrompt: true
                              })
                            } else {
                              this.startCollectiveInvoiceCreateProcess("first");
                            }
                          }}
                          disabled={this.state.removed}
                          style={{ padding: "1px 16px" }}
                        >
                          <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-file-pdf"></div></ListItemIcon>
                          <ListItemText primary={this.trans("launchpanel-menuitem/createfirstinvoice")} secondary={this.trans("hint/launch-panel-create-rent-statement")} />
                        </ListItem>
                      }
                      {
                        this.state.contract?.endDate &&
                        <ListItem
                          button
                          alignItems="flex-start"
                          key="menuitem-create-last-invoice"
                          onClick={() => {
                            const unit = this.props.units.byId[this.state.contract.unitId]
                            if (unit?.unitServiceStatus.label === "INACTIVE") {
                              this.props.dispatch({
                                type: Constants.SNACKBAR_ADD_MESSAGE,
                                payload: {
                                  message: this.trans("archived_unit"),
                                  type: "error"
                                }
                              });
                            } else if (this.checkProcessIsBusy({
                              action: "createInvoice",
                              entityName: "contract",
                              entity: this.state.contract
                            })) {
                              this.openIsBusyPopup();
                              this.setState({ anchorEl: null });
                            } else if (this.state.hasModifiedData) {
                              this.setState({
                                isErrorLaunchPanelOpen: true,
                                anchorEl: null,
                                openLeavePrompt: true
                              })
                            } else {
                              this.startCollectiveInvoiceCreateProcess("last");
                            }
                          }}
                          disabled={this.state.removed}
                          style={{ padding: "1px 16px" }}
                        >
                          <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-file-pdf"></div></ListItemIcon>
                          <ListItemText primary={this.trans("launchpanel-menuitem/createlastinvoice")} secondary={this.trans("hint/launch-panel-create-final-statement")} />
                        </ListItem>
                      }
                      <ListItem
                        button
                        key={`create_pdf`}
                        alignItems="flex-start"
                        onClick={() => {
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorElCharge: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.setState({
                              isCreatePdfPopupOpen: true
                            })
                          }
                        }}
                        style={{ padding: "1px 16px" }}
                      >
                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-file-pdf"></div></ListItemIcon>
                        <ListItemText primary={this.trans("contract-launch-panel-create-pdf")} secondary={this.trans("contract-launch-panel-create-pdf-hint")} />
                      </ListItem>

                      <ListItem
                        button
                        key={`send_invoice_email`}
                        alignItems="flex-start"
                        onClick={() => {
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorElCharge: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.setState({
                              hasModifiedData: false,
                              anchorElCharge: null
                            }, () => {
                              if (this.state.attachments.some(a => a.automaticallyCreated)) {
                                this.redirect(`/app/email/send/contract/${this.state.contract?.id}`)
                              } else {
                                this.createPdf(() => this.redirect(`/app/email/send/contract/${this.state.contract?.id}`));
                              }
                            })
                          }
                        }}
                        style={{ padding: "1px 16px" }}
                      >

                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-email"></div></ListItemIcon>
                        <ListItemText primary={this.trans("page/invoiceupdate-link/sendinvoice")} secondary={this.trans("page/invoiceupdate-link/sendcontract-hint")} />
                      </ListItem>

                      <ListItem
                        button
                        key={`send_landlord_email`}
                        alignItems="flex-start"
                        onClick={() => {
                          if (this.state.hasModifiedData) {
                            this.setState({
                              isErrorLaunchPanelOpen: true,
                              anchorElCharge: null,
                              openLeavePrompt: true
                            })
                          } else {
                            this.setState({
                              hasModifiedData: false,
                              anchorElCharge: null
                            }, () => {
                              this.redirect(`/app/email/send/renewed-contract/${this.state.contract?.id}`)
                            })
                          }
                        }}
                        style={{ padding: "1px 16px" }}
                      >

                        <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-email"></div></ListItemIcon>
                        <ListItemText primary={this.trans("launch-panel-send-to-landlord")} secondary={this.trans("hint/launch-panel-send-to-landlord")} />
                      </ListItem>


                      {this.state.showAllFields &&
                        <>
                          {
                            this.state.contract?.isActive &&
                            <ListItem
                              button
                              alignItems="flex-start"
                              onClick={() => {
                                const unit = this.props.units.byId[this.state.contract.unitId]
                                if (unit?.unitServiceStatus.label === "INACTIVE") {
                                  this.props.dispatch({
                                    type: Constants.SNACKBAR_ADD_MESSAGE,
                                    payload: {
                                      message: this.trans("archived_unit"),
                                      type: "error"
                                    }
                                  });
                                } else if (this.checkProcessIsBusy({
                                  action: "createCharges",
                                  entityName: "contract",
                                  entity: this.state.contract
                                }) || (this.state.contract && this.state.contract.isBusy)) {
                                  this.openIsBusyPopup();
                                  this.setState({ anchorEl: null });
                                } else if (this.state.hasModifiedData) {
                                  this.setState({
                                    isErrorLaunchPanelOpen: true,
                                    anchorEl: null,
                                    openLeavePrompt: true
                                  })
                                } else {
                                  this.setState({ anchorEl: null }, () => this.checkPeriodForCreateChargesNextMounthDialog());
                                }
                              }}
                              style={{ padding: "1px 16px" }}
                            >
                              <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-link"></div></ListItemIcon>
                              <ListItemText primary={this.trans("menuitem-create-charges-for-next-period")} secondary={this.trans("hint/launch-panel-create-charge-uncoming-period")} />
                            </ListItem>
                          }
                          {
                            (this.state.contract?.isSigned || this.state.contract?.isExpiring) &&
                            <ListItem
                              button
                              alignItems="flex-start"
                              key="menuitem-renew"
                              onClick={() => {
                                const unit = this.props.units.byId[this.state.contract.unitId]
                                if (unit?.unitServiceStatus.label === "INACTIVE") {
                                  this.props.dispatch({
                                    type: Constants.SNACKBAR_ADD_MESSAGE,
                                    payload: {
                                      message: this.trans("archived_unit"),
                                      type: "error"
                                    }
                                  });
                                } else if (this.checkProcessIsBusy({
                                  action: "renew",
                                  entityName: "contract",
                                  entity: this.state.contract
                                })) {
                                  this.openIsBusyPopup();
                                  this.setState({ anchorEl: null });
                                } else if (this.state.hasModifiedData) {
                                  this.setState({
                                    isErrorLaunchPanelOpen: true,
                                    anchorEl: null,
                                    openLeavePrompt: true
                                  })
                                } else {
                                  this.setState({ isRenewDialogOpen: true, anchorEl: null })
                                }
                              }}
                              disabled={this.state.removed}
                              style={{ padding: "1px 16px" }}
                            >
                              <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-extend"></div></ListItemIcon>
                              <ListItemText primary={this.trans("launchpanel/option-renew")} secondary={this.trans("hint/launch-panel-renew-contract")} />
                            </ListItem>
                          }

                          {!this.state.contract?.removed && !this.state.contract?.isConcept && (<ListItem
                            button
                            alignItems="flex-start"
                            key="menuitem-notification"
                            onClick={() => {
                              this.setState({
                                notificationDialogIsOpen: true,
                              })
                            }}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-notification"></div></ListItemIcon>
                            <ListItemText primary={this.trans("menuitem-create-notification")} secondary={this.trans("menuitem-create-notification-hint")} />
                          </ListItem>)}
                          <ListItem
                            button
                            alignItems="flex-start"
                            key="menuitem-delete"
                            onClick={() => {
                              if (this.checkProcessIsBusy({
                                action: "remove",
                                entityName: "contract",
                                entity: this.state.contract
                              })) {
                                this.openIsBusyPopup();
                                this.setState({ anchorEl: null });
                              } else {
                                this.openDeleteContractDialog(this.state.contract);
                              }
                            }}
                            style={{ padding: "1px 16px" }}
                          >
                            <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-remove"></div></ListItemIcon>
                            <ListItemText primary={this.trans("menuitem-delete-contract")} secondary={this.trans("menuitem-delete-contract-hint")} />
                          </ListItem>

                        </>
                      }

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          backgroundColor: "#e6e6e6",
                          padding: "6px 0",
                          marginTop: "8px"
                        }}
                        onClick={() => this.setState({
                          showAllFields: !this.state.showAllFields
                        })}
                      >
                        {
                          this.state.showAllFields ?
                            <ExpandLess /> :
                            <ExpandMore />
                        }
                        <div>{this.state.showAllFields ? this.trans("title-less").toUpperCase() : this.trans("title-more").toUpperCase()}</div>
                      </div>
                    </List>
                  }
                />
              )
            }

            {this.isBeta() &&
              <Timeline
                {...this.props}
                relations={{
                  unitId: this.state.contract?.unitId,
                  contractId: this.state.contract?.id,
                  contactId: this.state.contract?.mainTenantContactId,
                  companyId: this.state.contract?.mainTenantCompanyId,
                }}
                entityEvents={this.state.events}
                fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.contract?.id)}
                fetchingEvents={this.state.fetchingEvents}
              />
            }
          </div>
        </div>

        {/* // Signing pre process popups */}
        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={
            <div>
              <div style={{ marginBottom: "10px" }}>{this.trans("contract-sign-warning")}</div>
              <div style={{ marginBottom: "10px" }}>{this.trans("contract-sign-warning-1", { firstDate: this.formatter.formatDate(this.state.firstDate) })}</div>

              {(this.state.financialStartDate > this.state.firstDate) &&
                <div>
                  <hr />
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", marginBottom: "10px" }}>
                    <ListItemIcon style={{ minWidth: 0, marginRight: "5px" }}><div className="icon icon-ic-info info-text-blue"></div></ListItemIcon>
                    <div>{this.trans("contract-sign-warning-2", { agencyName: this.state.ownerName, financialStartDate: this.formatter.formatDate(this.state.financialStartDate) })}</div>
                  </div>
                  <div>{this.trans("contract-sign-warning-3")}</div>
                </div>}
            </div>
          }
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-continue")}
          openLeavePrompt={this.state.isContractSigningPopupOpen}
          prioritizeClosing={true}
          onDiscard={this.cancelSigningProcess}
          onSave={() => {
            this.setState({ isContractSigningPopupOpen: false, contractSigningPopupWasShown: true }, this.save);
          }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={this.trans("you-did-not-create-charge-rent")}
          negativeButtonLabel={this.trans("dialog-button/no")}
          positiveButtonLabel={this.trans("dialog-button/yes")}
          openLeavePrompt={this.state.isRentContractSigningPrePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              isRentContractSigningPrePopupOpen: false,
              isRentPriceCreatePopupOpen: false,
              rentPriceCreatePopupWasShown: true
            }, this.save)
          }}
          onSave={() => {
            this.setState({ isContractSigningPopupOpen: false, isRentContractSigningPrePopupOpen: false, isRentPriceCreatePopupOpen: true });
          }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={this.trans("you-did-not-create-charge-deposit")}
          negativeButtonLabel={this.trans("dialog-button/no")}
          positiveButtonLabel={this.trans("dialog-button/yes")}
          openLeavePrompt={this.state.isDepositContractSigningPrePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              isDepositContractSigningPrePopupOpen: false,
              isDepositPriceCreatePopupOpen: false,
              depositPriceCreatePopupWasShown: true
            }, this.save)
          }}
          onSave={() => {
            this.setState({ isContractSigningPopupOpen: false, isDepositContractSigningPrePopupOpen: false, isDepositPriceCreatePopupOpen: true });
          }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={this.trans("you-did-not-create-agency-fee")}
          negativeButtonLabel={this.trans("dialog-button/no")}
          positiveButtonLabel={this.trans("dialog-button/yes")}
          openLeavePrompt={this.state.isAgencyFeeContractSigningPrePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              isAgencyFeeContractSigningPrePopupOpen: false,
              isAgencyFeeСreatePopupOpen: false,
              agencyFeeCreatePopupWasShown: true
            }, this.save)
          }}
          onSave={() => {
            this.setState({ isContractSigningPopupOpen: false, isAgencyFeeContractSigningPrePopupOpen: false, isAgencyFeeСreatePopupOpen: true });
          }}
          hideCross={true}
        />


        {/* // Signing process popups */}
        <PromptDialog
          {...this.props}
          title={this.trans("dialog/contractitemdetails-title")}
          content={
            <div>
              <ChargeTemplateCreate
                {...this.props}
                entity={"contract"}
                selectedType={TypeContainer.pickIdFromLabel("Basic_rent")}
                firstDate={new Date(this.state.firstDate)}
                endDate={this.state.contract?.endDate}
                contact={this.state.selectedTenant instanceof Person ? this.state.selectedTenant : null}
                company={this.state.selectedTenant instanceof Company ? this.state.selectedTenant : null}
                onSave={this.addChargeTemplate}
                onSaveCallback={() => {
                  this.setState({
                    isRentPriceCreatePopupOpen: false,
                    rentPriceCreatePopupWasShown: true
                  }, this.save)
                }}
                onCancel={this.cancelSigningProcess}
                positiveButtonLabel={this.trans("button-continue")}
                negativeButtonLabel={this.trans("button-cancel")}
                additionalButton={
                  (
                    <Button
                      key="dialog-additional-btn"
                      color="primary"
                      onClick={() => {
                        this.setState({
                          isRentPriceCreatePopupOpen: false,
                          rentPriceCreatePopupWasShown: true
                        }, this.save)
                      }}
                    >
                      {this.trans("label-skip")}
                    </Button>
                  )
                }
              />
            </div>
          }
          openLeavePrompt={this.state.isRentPriceCreatePopupOpen}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
          hideCross={true}
          existingChargeTemplates={this.state.chargeTemplates}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/contractitemdetails-title")}
          content={
            <div>
              <ChargeTemplateCreate
                {...this.props}
                entity={"contract"}
                existingChargeTemplates={this.state.chargeTemplates}
                selectedType={TypeContainer.pickIdFromLabel("Deposit")}
                firstDate={new Date(this.state.firstDate)}
                endDate={this.state.contract?.endDate}
                contact={this.state.selectedTenant instanceof Person ? this.state.selectedTenant : null}
                company={this.state.selectedTenant instanceof Company ? this.state.selectedTenant : null}
                isCollective={false}
                onSave={this.addChargeTemplate}
                onSaveCallback={() => {
                  this.setState({
                    isDepositPriceCreatePopupOpen: false,
                    depositPriceCreatePopupWasShown: true
                  }, this.save)
                }}
                onCancel={this.cancelSigningProcess}
                positiveButtonLabel={this.trans("button-continue")}
                negativeButtonLabel={this.trans("button-cancel")}
                additionalButton={
                  (
                    <Button
                      key="dialog-additional-btn"
                      color="primary"
                      onClick={() => {
                        this.setState({
                          isDepositPriceCreatePopupOpen: false,
                          depositPriceCreatePopupWasShown: true
                        }, this.save)
                      }}
                    >
                      {this.trans("label-skip")}
                    </Button>
                  )
                }
              />
            </div>
          }
          openLeavePrompt={this.state.isDepositPriceCreatePopupOpen}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          subtitle={this.trans("dialog-add-agency-fee-subtitle")}
          content={
            <div>
              <AgencyFeeCreate
                {...this.props}
                objectType={AgencyFeeContainer.pickIdFromLabel("Contract")}
                objectId={this.state.contract && this.state.contract.id}
                showDates={true}
                onSave={this.addAgencyFeeFromSignProcessDialog}
                onCancel={this.closeAgencyFeeDialog}
                positiveButtonLabel={this.trans("button-continue")}
                negativeButtonLabel={this.trans("button-cancel")}
                additionalButton={
                  (
                    <Button
                      key="dialog-additional-btn"
                      color="primary"
                      onClick={() => {
                        this.setState({
                          isAgencyFeeСreatePopupOpen: false,
                          agencyFeeCreatePopupWasShown: true
                        }, this.save)
                      }}
                    >
                      {this.trans("label-skip")}
                    </Button>
                  )
                }
              />
            </div>
          }
          openLeavePrompt={this.state.isAgencyFeeСreatePopupOpen}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={
            <div>
              <span>{this.trans("title-remove-savings-payment-warning")}</span>
            </div>}
          openLeavePrompt={this.state.cannotDeleteSavingsChargeDialog}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({ cannotDeleteSavingsChargeDialog: false })}
          onlyPositiveButton={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={(
            <div>
              <p style={{ marginTop: "0" }}>{this.trans("first-date-in-the-past-ask-automatically-create-payments")}</p>

              <DatePickerComponent
                {...this.props}
                id="payChargesUntilDate"
                name="payChargesUntilDate"
                label={this.trans("date-pay-charges-until")}
                initialDate={this.state.payChargesUntilDate}
                onChange={date => this.selectDate(date, "payChargesUntilDate")}
                minDate={this.state.firstDate}
                minDatePlusDays={1}
                clearButton={true}
                width="60%"
                error={this.state.datepickerError}
              />
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-continue")}
          openLeavePrompt={this.state.isPayUntilDatePopupOpen}
          prioritizeClosing={true}
          onDiscard={this.cancelSigningProcess}
          additionalBtns={(
            [
              <Button
                key="dialog-additional-btn"
                color="primary"
                onClick={() => {
                  this.setState({
                    isPayUntilDatePopupOpen: false,
                    payUntilDatePopupWasShown: true,
                    shouldApplyPayChargesUntilDate: false
                  }, this.save)
                }}
              >
                {this.trans("label-skip")}
              </Button>
            ]
          )}
          onSave={() => {
            this.setState({
              isPayUntilDatePopupOpen: false,
              payUntilDatePopupWasShown: true,
              shouldApplyPayChargesUntilDate: true
            }, this.save)
          }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.state.newChargeTemplatePopupOpen ? this.trans("dialog/newcontractitems-title") : this.trans("dialog/contractitemdetails-title")}
          content={this.getChargeTemplatePopupContent()}
          openLeavePrompt={this.state.isChargeTemplatePopupOpen}
          onClose={this.closeChargeTemplatePopup}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={<div>{this.state.typeOfCollectiveInvoice === "first" ? this.trans("coach/collectiveinvoice-preprocess/info") : this.trans("coach/collectiveinvoice-preprocess/infonotfoundcharges")}</div>}
          openLeavePrompt={this.state.isPreProcessCreateCollectiveInvoiceCoachOpen}
          onSave={() => {
            this.setState({
              isPreProcessCreateCollectiveInvoiceCoachOpen: false
            })
          }}
          positiveButtonLabel={this.trans("button-close")}
          onlyPositiveButton={true}
          prioritizeClosing={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={<div>{this.trans("coach/collectiveinvoice-preprocess/infoisnotsigned")}</div>}
          openLeavePrompt={this.state.isContractSignPreProcessCollectiveInvoiceDilaog}
          onSave={() => {
            this.setState({
              isContractSignPreProcessCollectiveInvoiceDilaog: false
            })
          }}
          positiveButtonLabel={this.trans("button-close")}
          onlyPositiveButton={true}
          prioritizeClosing={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={<div>{this.trans("coach/collectiveinvoice-preprocess/enddateisnotset")}</div>}
          openLeavePrompt={this.state.isContractHaveEndDatePreProcessCollectiveInvoiceDialog}
          onSave={() => {
            this.setState({
              isContractHaveEndDatePreProcessCollectiveInvoiceDialog: false
            })
          }}
          positiveButtonLabel={this.trans("button-close")}
          onlyPositiveButton={true}
          prioritizeClosing={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("end-contract-modal-title")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-endcontract-info1")}</p>
              <div style={{ width: "50%" }}>
                <DatePickerComponent
                  {...this.props}
                  label={this.state.endDate ?
                    this.trans("end-date") : this.trans("label-click-set-the-end-date")}
                  initialDate={this.state.endDate ? this.state.endDate : null}
                  onChange={date => this.selectDate(date, "endDate")}
                  clearButton={true}
                  minDate={this.state.firstDate}
                  minDatePlusDays={1}
                  minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                  error={this.state.endDateNotValid && this.trans("be_ajv_not_validated")}
                />
              </div>
              <p>{this.trans("dialog/preprocess-endcontract-info2")}</p>
              <p>{this.state.contract && !!this.state.contract.isActive && this.trans("dialog/preprocess-endcontract-info3")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("end-contract")}
          positiveButtonStyle={{ backgroundColor: "red" }}
          openLeavePrompt={this.state.isEndContractDialogOpen}
          prioritizeClosing={true}
          onDiscard={() => this.setState({ isEndContractDialogOpen: false, endDate: this.state.contract && this.state.contract.endDate })}
          onSave={() => this.saveEndDate(this.state.contract)}
          hideCross={true}
          additionalBtns={this.state.contract && !!this.state.contract && this.state.contract.isActive && (
            [<Button
              key="dialog-additional-btn"
              color="primary"
              onClick={() => this.redirect(`/app/contract/extend/${this.state.contract && this.state.contract.id}`)}
            >
              {this.trans("renew-contract")}
            </Button>]
          )}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("renew-contract")}
          content={(
            <div>
              <p>{this.trans("dialog/renewcontract-info1")}</p>
              <p>{this.trans("dialog/renewcontract-info2")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("renew-contract")}
          openLeavePrompt={this.state.isRenewDialogOpen}
          prioritizeClosing={true}
          onDiscard={() => this.setState({ isRenewDialogOpen: false })}
          onSave={() => {
            this.setState({
              isRenewDialogOpen: false,
              isRenewCoachOpen: true
            })
          }}
          hideCross={true}
        />

        {this.state.isAdjustRentCoachOpen &&
          <CoachIncreaseRentDialog
            {...this.props}
            openCoachIncreaseRent={this.state.isAdjustRentCoachOpen}
            contract={this.state.contract}
            expirationDate={this.state.expirationDate}
            rentNotificationText1={this.state.notifications[0]?.content?.name}
            rentNotificationText2={this.state.notifications[0]?.content?.name}
            onCloseIncreaseRentCoach={(contract, success: boolean) => {
              this.setState({
                isAdjustRentCoachOpen: false
              })
              if (success) {
                return this.redirect(`/app/email/send/new-contract/${contract?.id}`);
              }
            }}
          />
        }

        {this.state.isRenewCoachOpen &&
          <CoachRenewContract
            {...this.props}
            openCoachRenewContract={this.state.isRenewCoachOpen}
            contract={this.state.contract}
            onCloseRenewContractCoach={(contract, success: boolean) => {
              this.setState({
                isRenewCoachOpen: false
              }, () => {
                if (success) {
                  this.redirect(`/app/contract/update/${contract?.id}`);
                  setTimeout(() => {
                    return this.redirect(`/app/email/send/new-contract/${contract?.id}`);
                  }, 0);
                }
              })
            }}
          />
        }

        <PromptDialog
          {...this.props}
          title={this.trans("title-date")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-info/checkfirstdate")}</p>
              <p>{this.trans("dialog/preprocess-info2/checkfirstdate")}</p>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-continue")}
          openLeavePrompt={this.state.isCheckEndDateIsFirstDateOfMonthDialogOpen}
          prioritizeClosing={true}
          onDiscard={() => this.setState({ isCheckEndDateIsFirstDateOfMonthDialogOpen: false })}
          onSave={() => { this.setState({ isCheckEndDateIsFirstDateOfMonthDialogOpen: false, shouldSkipEndDateCheck: true }, () => this.selectDate(this.state.checkedEndDate, "endDate")); }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("breadcrumbs-label-notification")}
          content={(
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{ display: "flex", alignItems: "start" }}>
                  <DatePickerComponent
                    {...this.props}
                    label={this.trans("contract-expiration-date")}
                    initialDate={this.state.updatingNotificationDate}
                    value={this.state.updatingNotificationDate}
                    minDate={new Date()}
                    minDatePlusDays={0}
                    onChange={date => this.setState({ updatingNotificationDate: Time.formatOrNull(date) })}
                    clearButton={true}
                    error={this.state.updatingNotificationDate === null}
                  />
                  <TextField
                    type="text"
                    value={this.state.updatingNotificationText}
                    onChange={(e) => this.setState({ updatingNotificationText: e.target.value })}
                    style={{ marginLeft: "10px" }}
                    label={this.trans("dialog-new-notification-text")}
                    error={!this.state.updatingNotificationText?.trim()}
                  />
                </div>

                {/* <Link
                  onClick={(e) => this.setState({ rentNotificationText: "", hasModifiedData: true, expirationDate: null })}
                  style={{ marginLeft: "15px" }}
                >
                  {this.trans("button-clear")}
                </Link> */}
              </div>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-save")}
          openLeavePrompt={this.state.isExpirationContractDialogOpen}
          prioritizeClosing={true}
          onDiscard={() => this.setState({ expirationDate: this.state.rentNotification?.remindDate, rentNotificationText: this.state.rentNotification?.content?.name, hasModifiedData: false }, this.closeExpirationContractDialog)}
          onSave={() => { this.saveExpirationDate(this.state.updatingEvent); }}
          positiveButtonDisabled={!this.isNotificationValid()}
        />

        <PromptDialog
          title={this.trans("change-email")}
          content={(
            <div>
              <TextField
                defaultValue={this.state.contract?.addressForRentEmail ? this.state.contract.addressForRentEmail : this.state.contract?.person.email}
                autoComplete='email'
                id="email"
                name="email"
                className="form-element full-size scroll-to-email"
                type="email"
                onChange={(e) => this.setState({ addressForRentEmail: e.target.value })}
                variant="standard"
                error={!!this.getErrorFor("email")}
                helperText={this.getErrorFor("email")}
              />
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-save")}
          openLeavePrompt={this.state.isChangeEmailDialogOpen}
          prioritizeClosing={true}
          onDiscard={() => this.setState({ addressForRentEmail: null }, this.closeChangeEmailDialogOpen)}
          onSave={() => { this.closeChangeEmailDialogOpen(); this.saveAddressForRentEmail(this.state.contract); }}
        />

        <PromptDialog
          openLeavePrompt={this.state.createChargesForNextPeriodDialogOpen}
          title={this.trans("dialog/preprocess-createchargesnextmonth/title")}
          content={this.trans("dialog/createchargesfornextmonth-info", { period: Time.useFormat(this.state.nextPeriodForCharges, "MMMM YYYY") })}
          positiveButtonLabel={!this.state.nextPeriodForCharges ? this.trans("dialog-button/close") : this.trans("dialog-button/continue")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onlyPositiveButton={!this.state.nextPeriodForCharges}
          onSave={() => {
            if (!this.state.nextPeriodForCharges) {
              this.setState({ createChargesForNextPeriodDialogOpen: false })
            } else {
              this.setState({ createChargesForNextPeriodDialogOpen: false }, this.createChargesForNextMounth)
            }
          }}
          onDiscard={() => this.setState({ createChargesForNextPeriodDialogOpen: false })}
          {...this.props}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'agency-fee-remove-from-settings-page'}
          isOpen={this.state.isAgencyRemoveDialog}
          onCancel={this.closePrompt}
          onDelete={this.deleteAgencyFee}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-delete-contract")}
          content={
            this.state.contract && (this.state.contract.isConcept || this.state.contract.isDropped) ?
              <div>
                <p>{this.trans("dialog/preprocess-removenotsignedcontract", {
                  tenant: this.state.contract && this.state.contract.person ? this.state.contract.person.displayName : ""
                })}
                </p>
              </div>
              :
              this.state.contract && this.state.contract.previousContractId ?
                <div>
                  <p>{this.trans("dialog/preprocess-removesignedcontract-baseverison")}</p>
                  <p>{this.trans("dialog/preprocess-removesignedcontract-renewedverison")}</p>
                </div>
                :
                <div>
                  <p>{this.trans("dialog/preprocess-removesignedcontract-baseverison")}</p>
                </div>
          }
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.state.contract && (this.state.contract.isConcept || this.state.contract.isDropped) ? this.trans("button-remove") : this.state.labelForRemoveButton}
          positiveButtonDisabled={this.state.contract && (this.state.contract.isConcept || this.state.contract.isDropped) ? false : this.state.isRemoveButtonDisabled}
          openLeavePrompt={this.state.isDoYouWantToDeleteContractDialogOpen}
          prioritizeClosing={true}
          positiveButtonStyle={{ backgroundColor: "red" }}
          onDiscard={this.closeDeleteContractDialog}
          onSave={() => this.deleteContract(this.state.contract)}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isOpenAlreadyCreatedCollectiveInvoiceDialog}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.trans("preprocess/collectiveinvoice-info/alreadycreatedinvoiceoption")}
          positiveButtonLabel={this.trans("dialog-button/send")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.setState({ isOpenAlreadyCreatedCollectiveInvoiceDialog: false }, this.startSendingProcess)}
          onDiscard={() => this.setState({ isOpenAlreadyCreatedCollectiveInvoiceDialog: false })}
          additionalBtns={(
            [
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.setState({ isOpenAlreadyCreatedCollectiveInvoiceDialog: false }, this.startPrintingProcess)
                }
                }
              >
                {this.trans("button-view")}
              </Button>
            ]
          )}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isOpenAlreadyPreProcessCreatedCollectiveInvoiceDialog}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.trans("preprocess/collectiveinvoice-info/alreadycreatedinvoice")}
          positiveButtonLabel={this.trans("dialog-button/replace")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.setState({ isOpenAlreadyPreProcessCreatedCollectiveInvoiceDialog: false }, () => this.fetchContractUnpaidCharges(this.state.contract?.id))}
          onDiscard={() => this.setState({ isOpenAlreadyPreProcessCreatedCollectiveInvoiceDialog: false })}
          additionalBtns={(
            [
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.setState({
                    isOpenAlreadyPreProcessCreatedCollectiveInvoiceDialog: false,
                    isOpenAlreadyCreatedCollectiveInvoiceDialog: true
                  })
                }
                }
              >
                {this.trans("dialog-button/reuse")}
              </Button>
            ]
          )}
        />

        {this.state.notificationDialogIsOpen && <NewNotificationDialog
          {...this.props}
          entity={this.state.contract}
          isOpen={this.state.notificationDialogIsOpen}

          initializePage={() => {
            this.setState({
              hasModifiedData: false,
            }, () => { this.fetchEntityEvents(this.state.contract?.id) })
          }}

          closeDialog={() => {
            this.setState({
              notificationDialogIsOpen: false,
              isSaving: false,
              anchorEl: null,
            }, () => { this.fetchEntityEvents(this.state.contract?.id) })
          }}
        />}


        <CoachNewTenantDialog
          {...this.props}
          openCoachCreateNewTenant={this.state.openCoachCreateNewTenant}
          existingTenant={this.state.selectedTenant instanceof Company ? this.state.selectedTenant : null}
          onCloseTenantCoach={entity => {
            if (entity) {
              this.setState({
                openCoachCreateNewTenant: false
              }, () => this.selectTenant(entity, true))
            } else {
              this.setState({
                openCoachCreateNewTenant: false
              })
            }
          }}
        />

        <CoachCollectiveInvoiceDialog
          {...this.props}
          openCreateCollectiveInvoiceCoachOpen={this.state.isCreateCollectiveInvoiceCoachOpen}
          contract={this.state.contract}
          unpaidContractCharges={this.state.unpaidContractCharges}
          typeOfCollectiveInvoice={this.state.typeOfCollectiveInvoice}

          openCollectiveInvoiceCoachDialog={this.openCollectiveInvoiceCoachDialog}
          onCloseCollectiveInvoiceCoach={this.onCloseCollectiveInvoiceCoach}
        />

        <ChargeCreateDialog
          {...this.props}
          isOpened={this.state.isChargeCreatePopupOpen}
          title={this.trans("title-new-charge")}
          selectedEntity={this.state.contract}
          selectedCounterpartyForCharge={this.state.openChargeCreatePopupLaunchPanel ? this.state.selectedTenant : null}
          defaultChargeTypeId={this.state.openChargeCreatePopupLaunchPanel ? TypeContainer.pickIdFromLabel("Other_receivable") : null}
          defaultChargeTypeLabel={this.state.openChargeCreatePopupLaunchPanel ? "Other_receivable" : null}
          onCancel={this.closeChargeCreatePopup}
        />

        {this.state.isCoachNewChargeOpen && (
          <CoachNewCharge
            {...this.props}
            openCoach={this.state.isCoachNewChargeOpen}
            selectedObjectForNewCharge={this.state.contract}
            onCloseCoach={(success: boolean = false, charge) => {
              this.setState({
                isCoachNewChargeOpen: false
              }, () => {
                if (success) {
                  return this.redirect(`/app/charge/update/${charge.id}`)
                }
              })
            }}
            selectedOwnerForNewCharge={this.state.contract?.unit?.property?.company}
            defaultChargeTypeId={TypeContainer.pickIdFromLabel("Other_receivable")}
            defaultChargeTypeLabel={"Other_receivable"}
          />
        )}

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.showTenantEmailPopup}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.state.contract?.tenant instanceof Person ? this.trans("dialog/auto-email-send/tenant-email-notfound") : this.trans("dialog/auto-email-send/company-tenant-email-notfound")}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => {
            if (this.state.contract?.tenant instanceof Person) {
              this.props.dispatch({
                type: Constants.OPEN_PERSON_UPDATE_BY_DEFAULT,
              });
              return this.redirect(`/app/person/update/${this.state.contract?.tenant?.id}`);
            }
            if (this.state.contract?.tenant instanceof Company) {
              return this.redirect(`/app/owner/update/${this.state.contract?.tenant?.id}`);
            }
          }}
          onDiscard={() => this.setState({ showTenantEmailPopup: false })}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.state.isErrorLaunchPanelOpen ? () => this.setState({ openLeavePrompt: false, hasModifiedData: false, additionalSectionHasModifiedData: false }) : this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isCreatePdfPopupOpen}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.trans("dialog/create-pdf-contract-title")}
          positiveButtonLabel={this.trans("dialog-button/create")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={this.createPdf}
          onDiscard={() => this.setState({ isCreatePdfPopupOpen: false })}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    charges: state.charges,
    units: state.units,
    component: state.contractUpdate,
    chargeTemplateCreate: state.chargeTemplateCreate,
    chargeTemplateUpdate: state.chargeTemplateUpdate,
    globalTypes: state.globalTypes,
    agencyFeeCreate: state.agencyFeeCreate,
    agencyFeeUpdate: state.agencyFeeUpdate,
    events: state.events,
  };
};

export default connect(mapStateToProps)(ContractUpdate);